<template>
  <!-- 系统整体页面布局 -->
  <el-container class="el-container">
    <!-- 页面头部区域 高度默认60px -->
    <el-header :class="$store.getters.showHeader == true ? 'el-header' : 'el-header1'">
      <div :style="{ display: $store.getters.showHeader == true ? 'block' : 'none',
        }">
        <img style="width: 95px; height:25px;float: left; " src="../assets/LOGO_1.png" />
        <!-- <div class="contract">
          <i @click="contractEvt(1)" v-if="contractNum == 2" class="el-icon-s-unfold"></i>
          <i @click="contractEvt(2)" v-else class="el-icon-s-fold"></i>
        </div> -->
        <!-- <div class="contract" style="height: 33px;background: #d1d1d1;padding:0 3px">
          <span id="abroad" class="switching" @click="updateLocation">国外</span>
        </div> -->
      </div>
      <div class="headerMenu" :style="{ display: $store.getters.showHeader == true ? 'block' : 'none' }">
        <el-menu class="el-menu-demo" mode="horizontal" :default-active="activeIndex" @select="topMenuEvt">
          <el-menu-item index="1">参考图</el-menu-item>
          <el-menu-item index="2">模型</el-menu-item>
          <el-menu-item index="3">PS素材</el-menu-item>
          <el-menu-item index="4">用户</el-menu-item>
          <el-menu-item index="7">标签</el-menu-item>
          <el-menu-item index="5">收入</el-menu-item>
          <el-menu-item index="6">搜索</el-menu-item>
          <el-menu-item index="8">AI</el-menu-item>
          <el-menu-item index="9">工具</el-menu-item>

        </el-menu>
      </div>
      <div :style="{ display: $store.getters.showHeader == true ? 'block' : 'none' }"
        style="position: absolute;right: 20px;">
        <el-dropdown @command="outLoginEvt">
          <span class="el-dropdown-link">
            <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">退出登陆</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <!-- 左侧菜单栏部分 -->
      <el-aside class="el-aside">
        <el-scrollbar style="height: 100vh;" class="max_scroll">
          <div>
            <el-input placeholder="搜索" v-model="filterText" class="menus_input" @input="onFilter"></el-input>
            <el-tree class="filter-tree menu_scroll" :data="menuItems" :filter-node-method="filterNode" node-key="id"
              ref="tree" accordion style="margin-top: 10px;" :default-expanded-keys="['全部']" highlight-current
              @current-change="handleCurrentChange_evt">
              <div class="custom-tree-node" slot-scope="{ node }">
                <span style="width: 150px;overflow: hidden;" class="left_evt">{{ node.data.name }}</span>
                <span  :style="{ color: String(node.data.num) === '0' ? '#e3e3e3' : '' }">{{ String(node.data.num) }}</span>
              </div>
            </el-tree>
          </div>
        </el-scrollbar>
      </el-aside>
      <!-- 右侧主题页面内容展示 -->
      <el-main class="el-mian">
        <div v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <!-- 头部搜索分页盒子开始 -->
          <div :class="header == true ? 'search-box' : 'search-box1'"
            :style="{ width: $store.getters.contractNum == 2 ? '100%' : '' }">
            <div>
              <div style="display: flex;">
                <span @click="cleanUpEvt" class="all_text" style="height: 26px;margin-top: 10px;">All</span>
                <div @click="dialogVisible_one = true"
                  style=" margin-top: 10px;   width: 80px;height: 25px;cursor: pointer;display: flex;border: 1px solid #589ff9;margin-left:10px;justify-content: center;border-radius: 5px;margin-right: 10px;">
                  <span style="font-size: 14px">filter</span>
                </div>
                <div style="min-width: 850px;display: flex;flex-wrap: wrap;height: 70px;" class="width_ect">
                  <el-input v-if="checkInput" v-model="checkInput" style="width: 120px;margin-top:5px;margin-left:5px"
                    size="mini" @focus="searchLabel1Evt" placeholder="标签查询" clearable @clear="clearEvt1"
                    :class="checkInput == '' ? 'blue' : 'orange'" class="border_box_e"></el-input>

                  <el-input v-if="frontOrderInput" v-model="frontOrderInput"
                    style="width: 120px;margin-top:5px;margin-left:5px" size="mini" @focus="focusDiyIptEvt"
                    placeholder="ID查询" clearable @clear="clearEvt2" :class="frontOrderInput == '' ? 'blue' : 'orange'"
                    class="border_box_e" @change="selectImg()"></el-input>

                  <el-input v-if="authorInput" v-model="authorInput" style="width: 120px;margin-top:5px;margin-left:5px"
                    size="mini" placeholder="选择作者" @focus="focusDiyIptEvt" clearable
                    :class="authorInput == '' ? 'blue' : 'orange'" class="border_box_e"
                    @change="selectImg()"></el-input>



                  <el-date-picker v-if="value2 && value2.length" v-model="value2"
                    style="width: 240px;margin-top:5px;margin-left:5px" type="daterange" :picker-options="pickerOptions"
                    size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator="" class="border_box_e"
                    start-placeholder="添加时间" end-placeholder="结束时间" align="right"
                    :class="{ 'your-css-class': !isValue2Empty }" @change="selectImg()">
                  </el-date-picker>

                  <el-date-picker v-if="value1 && value1.length" v-model="value1"
                    style="width: 240px;margin-top:5px;margin-left:5px" type="daterange" :picker-options="pickerOptions"
                    size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator="" class="border_box_e"
                    start-placeholder="添加时间" end-placeholder="结束时间" align="right"
                    :class="{ 'your-css-class': !isValue1Empty }" @change="selectImg()">
                  </el-date-picker>
                  <el-date-picker v-if="value3 && value3.length" v-model="value3"
                    style="width: 240px;margin-top:5px;margin-left:5px" type="daterange" :picker-options="pickerOptions"
                    size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator="" class="border_box_e"
                    start-placeholder="添加时间" end-placeholder="结束时间" align="right"
                    :class="{ 'your-css-class': !isValue3Empty }" @change="selectImg()">
                  </el-date-picker>
                  <el-date-picker v-if="value4 && value4.length" v-model="value4"
                    style="width: 240px;margin-top:5px;margin-left:5px" type="daterange" :picker-options="pickerOptions"
                    size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator="" class="border_box_e"
                    align="right" :class="{ 'your-css-class': !isValue4Empty }" @change="selectImg()">
                  </el-date-picker>

                  <SizePopover style="margin-top:5px;margin-left:5px"
                    v-if="Object.keys(sizeRange_1) && Object.keys(sizeRange_1).length" class="size_ect"
                    :class="Object.keys(sizeRange_1).length ? 'orange' : 'blue'" @save="handleSave"
                    v-model="sizeRange_1" @clear="handleClear" ref="sizePopover1" />


                  <compress-size-input class="all_input_e" v-if="compressSize" label="" placeholder="请输入范围"
                    v-model="compressSize" :class="compressSize == '' ? 'blue' : 'orange'"
                    @update="handleUpdate('compressSize', $event)"></compress-size-input>



                  <el-select v-if="baoMi" class="border_box_e" v-model="baoMi"
                    style="width:120px;height: 28px;border:1px solid;margin-top:5px;margin-left:5px" clearable
                    @change="baoMi_e" :class="baoMi == '' ? 'blue' : 'orange'">
                    <el-option v-for="(option, index) in options2" :key="index" :label="option.label"
                      :value="option.value" style=" width:120px;height: 40px;">
                    </el-option>
                  </el-select>

                  <el-select v-if="pinFen" class="border_box_e" :class="pinFen == '' ? 'blue' : 'orange'"
                    v-model="pinFen" style="width:120px;height: 28px;border:1px solid;;margin-top:5px;margin-left:5px"
                    clearable @change="pinFen_e">
                    <el-option v-for="(option, index) in options3" :key="index" :label="option.label"
                      :value="option.value">
                    </el-option>
                  </el-select>
                  <compress-size-input v-if="xiazai_shu" class="all_input_e"
                    :class="xiazai_shu == '' ? 'blue' : 'orange'" v-model="xiazai_shu"
                    @update="handleUpdate('xiazai_shu', $event)" label="" placeholder="请输入范围"></compress-size-input>

                  <compress-size-input v-if="chaKan_shu" class="all_input_e"
                    :class="chaKan_shu == '' ? 'blue' : 'orange'" v-model="chaKan_shu"
                    @update="handleUpdate('chaKan_shu', $event)" label="" placeholder="请输入范围"></compress-size-input>


                  <el-input v-if="shouCang" class="border_box_e" placeholder="请输入范围" cla ss="border_box_e" clearable
                    v-model="shouCang" style="width: 120px;;margin-top:5px;margin-left:5px"
                    :class="shouCang == '' ? 'blue' : 'orange'" @change="selectImg()">
                  </el-input>
                </div>
              </div>
            </div>
            <!-- 头部搜索分页结束 -->
            <div class="block">
              <div class="pagination_box">
                <el-input v-model="paginationInput" style="width: 50px" size="mini" @change="limitEvt"
                  placeholder="请输入本页显示"></el-input>
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                  :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5"
                  :show-total="showTotal">
                </el-pagination>

                <div class="all-box" style="margin: 0px 10px ;">
                  <el-button type="primary" size="mini" @click="selectAllEvt" style="width: 78px"
                    :style="{ backgroundColor: selectAllBgColor }">{{ selectAllText }}</el-button>
                  <span> &nbsp; 已选中 </span>
                  <span>：{{ selectArr.length }} </span>
                </div>
                <div style="display: flex;align-items: center;">
                  <!-- <el-button type="primary" @click="uploadEvt" size="mini">上传素材</el-button> -->
                  <el-button type="info" @click="delete_Pop" size="mini">删除</el-button>

                  <el-dropdown :hide-on-click="false" @command="sortEvt">
                    <span class="el-dropdown-link select_e">
                      {{ sortName }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="9" :disabled="sort == 9 ? true : false">收藏最多</el-dropdown-item>
                      <el-dropdown-item command="7" :disabled="sort == 7 ? true : false">下载次数最多</el-dropdown-item>
                      <el-dropdown-item command="1" :disabled="sort == 1 ? true : false">上传时间-升序</el-dropdown-item>
                      <el-dropdown-item command="2" :disabled="sort == 2 ? true : false">上传时间-降序</el-dropdown-item>
                      <el-dropdown-item command="3" :disabled="sort == 3 ? true : false">文件大小-升序</el-dropdown-item>
                      <el-dropdown-item command="4" :disabled="sort == 4 ? true : false">文件大小-降序</el-dropdown-item>
                      <el-dropdown-item command="5" :disabled="sort == 5 ? true : false">文件尺寸-升序</el-dropdown-item>
                      <el-dropdown-item command="6" :disabled="sort == 6 ? true : false">文件尺寸-降序</el-dropdown-item>
                      <el-dropdown-item command="8" :disabled="sort == 8 ? true : false">点击查看次数最多</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <div class="dropdown-container" style="width: 80px;cursor: pointer;height: 30px;display: flex;"
                    @click="toggleDropdown">
                    <!-- 下拉菜单触发按钮 -->
                    <div class="dropdown-trigger">
                      <img :src="currentImageSrc" style="width: 20px; height: 20px; cursor: pointer;" />
                      <div class="arrow-icon"></div>
                    </div>
                    <!-- 下拉菜单 -->
                    <div v-if="isDropdownVisible" class="dropdown-menu">
                      <div v-for="(image, index) in images" :key="index" @click="selectImage(image)" class="menu-item">
                        <img :src="image.src" style="width: 20px; height: 20px; cursor: pointer;" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>

            <!-- 图片盒子开始 -->
            <el-scrollbar>
              <div class="img-box" v-if="changing !== 3">
                <div class="flex-images" @scroll="imgScrollEvt">
                  <div class="item" v-for="(e, index) in imgArr" :key="index" :data-w="changing == 1 ? '503' : e.width"
                    :data-h="changing == 1 ? '360' : e.height" @mousemove="mousemoveEvt(e)" @mouseout="mouseoutEvt"
                    @click.stop="imgEvt(e, index)" @contextmenu.prevent="rightClickEvt">
                    <img :src="e.thumb" />

                    <!-- checked为false  -->
                    <div class="select" :style="{ display: e.select == true ? 'block' : 'none' }"
                      v-if="checkValue == false">
                      <i class="el-icon-check"></i>
                    </div>
                    <!-- checked为true  -->
                    <div class="select1" v-if="checkValue == true ? true : false">
                      <span>{{ e.dup_num }}</span>
                    </div>
                    <!-- checked为true  -->
                    <div class="select" :style="{ display: e.select == true ? 'block' : 'none' }">
                      <i class="el-icon-check"></i>
                    </div>
                    <el-popover :style="{ display: e.select == true ? 'block' : 'none' }" class="operation_box"
                      v-if="checkValue == false" placement="right-start" width="230" trigger="manual"
                      v-model="e.leftSelect">
                      <div class="operation_center">
                        <div class="center_box" v-for="res in operationArr" :key="res.id">
                          <span>{{ res.title }}</span>
                          <el-checkbox-group class="check_min" v-model="res.selectArr" @change="checkbox1Evt(res)"
                            v-for="j in res.children" :key="j.id">
                            <el-checkbox :label="j.id">{{ j.title }}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div class="btn_box">
                          <el-button size="mini" ref="coverCancel" @click="cancelEvt(e)">取消</el-button>
                          <el-button type="primary" @click="changeImgEvt(e)" size="mini">确定</el-button>
                        </div>
                      </div>
                      <el-button slot="reference" @click.stop="leftSelectEvt(e)" icon="el-icon-s-operation"></el-button>
                    </el-popover>
                    <span class="id_text" v-if="e.source_id == mousemoveId && checkValue == false">id:{{ e.source_id
                      }}</span>

                    <div class="bottom_text">
                      <div></div>
                      <div>
                        <!-- <span v-if="favorite !==9&&review !==8">下载次数:{{ e.download_num }}</span>
                      <span v-else-if="review ==8">查看次数:{{ e.review }}</span>
                      <span v-else-if="favorite ==9">收藏次数:{{ e.favorite }}</span> -->
                        <b v-if="operateNum.show == true"></b>
                        <i v-if="operateNum.show == true && e.status == 0" style="background-color: green"></i>
                        <i v-else-if="operateNum.show == true && e.status == 1" style="background-color: #f00"></i>
                        <i v-else-if="operateNum.show == true && e.status == 3"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="height: 65px"></div>
            </el-scrollbar>
          </div>
          <!-- 标签操作弹窗开始 -->
          <el-dialog title="" :visible.sync="searchLabelDialog" width="51%" custom-class="searchLabel"
            :show-close="false" @open="searchDialogEvt">
            <div style="width: 90%; height: 100%">
              <div class="space" style="float: left; margin-left: 20px">
                <div class="check">
                  <div v-for="item in labelArr" :key="item.id">
                    <p>{{ item.title }}</p>
                    <div class="checkbox" v-for="e in item.children" :key="e.id" @click="labelSearchEvt(e)">
                      <i></i>
                      <b v-if="e.status == 3"></b>
                      <b v-else-if="e.status == 0" style="background-color: green"></b>
                      <b v-else-if="e.status == 1" style="background-color: #f00"></b>
                      <b v-else-if="e.status == 2" style="background-color: #999"></b>
                      <span class="space_title" :style="{
                        backgroundColor: e.finish == 1 ? '#e5e5e5' : 'none',
                        padding: '4px'
                      }">{{ e.title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>
          <!-- 标签操作弹窗结束 -->
          <!-- <SearchLabel :searchFor="searchFor" @cancel="cancel" :process="process" @revise="revise"
            @reviseText="reviseText" :author="authorInput" :time="value2" :frontOrder="frontOrderInput"
            :operateLabelInput="operateLabelInput" :labelId="labelId" :checkInput="checkInput" /> -->
          <!-- 右键弹窗开始 -->
          <el-dialog title="" :visible.sync="rightLabelDialog" width="51%" custom-class="searchLabel"
            :show-close="false" v-if="checkValue == false" @close="closeEvt" @open="rightDialogEvt">
            <div style="width: 90%; height: 600px">
              <div class="space" style="float: left; margin-left: 20px">
                <div class="check">
                  <div v-for="item in labelArr" :key="item.id">
                    <p :style="{ color: item.one == true ? '#409EFF' : '#595959' }">
                      {{ item.title }}
                    </p>
                    <div class="checkbox" v-for="e in item.children" :key="e.id" @click.stop="searchLabEvt(e)">
                      <i @click.stop="colorEvt(e)"></i>
                      <b @click.stop="colorEvt(e)" v-if="e.status == 3"></b>
                      <b @click.stop="colorEvt(e)" v-else-if="e.status == 0" style="background-color: green"></b>
                      <b @click.stop="colorEvt(e)" v-else-if="e.status == 1"
                        style="background-color: rgb(249, 157, 157)"></b>
                      <b @click.stop="colorEvt(e)" v-else-if="e.status == 2" style="background-color: #d1d1d1"></b>
                      <span :style="{
                        color:
                          e.status == 0
                            ? '#333'
                            : e.status == 1
                              ? '#d0d0d0'
                              : e.status == 2
                                ? '#d0d0d0'
                                : e.status == 3
                                  ? '#000'
                                  : '',
                        'font-weight': e.status == 0 ? '400' : ''
                      }">{{ e.title }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rightSearch">已选中:{{ selectArr.length }}</div>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="rightLabelDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="submitRightLabelEvt">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 右键弹窗结束 -->

          <el-dialog title="提示" :visible.sync="deleteVisible" width="30%" :before-close="handleClose">
            <span style="font-size: 14px">此操作将文件放进回收站, 是否继续?</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="deleteVisible = false">取 消</el-button>
              <el-button type="primary" @click="deleteEvt">确 定</el-button>
            </span>
          </el-dialog>

          <el-dialog title="提示" :visible.sync="deleteVisible_box" width="30%" :before-close="handleClose">
            <span style="font-size: 14px">此操作将文件放进回收站, 是否继续?</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="deleteVisible_box = false">取 消</el-button>
              <el-button type="primary" @click="deleteEvt_box">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 文件上传开始 -->
          <el-dialog title="上传参考" :visible.sync="uploadVisible" width="90%" :close-on-press-escape="true"
            :destroy-on-close="true">
            <Upload />
            <span slot="footer" class="dialog-footer"> </span>
          </el-dialog>

          <SpaceDialog_e :visible="dialogVisible" :data="imgArr" :active-index="activeIndex_copy"
            @update:visible="val => (dialogVisible = val)" before-close="clone_s" />

          <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo" :show-close="false">
            <div style="height:360px;">
              <span
                style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0 40px 30px 80px;"
                @click="cleanUpEvt">ALL</span>
              <div style="height:300px;display:flex">
                <div>
                  <div class="all_input">
                    <span>ID</span>
                    <el-input v-model="frontOrderInput" style="width: 160px;" size="mini" placeholder="ID查询" clearable
                      :class="frontOrderInput == '' ? 'blue' : 'orange'" class="border_box" @change="selectImg()">
                    </el-input>
                  </div>
                  <div class="all_input">
                    <span>作者</span>
                    <el-input v-model="authorInput" size="mini" placeholder="请输入" clearable
                      :class="authorInput == '' ? 'blue' : 'orange'" class="border_box" @change="selectImg()">
                    </el-input>
                  </div>
                </div>
                <div>
                  <div class="all_input">
                    <span>添加时间</span>
                    <el-date-picker style="width: 180px;height: 40px; margin-left: 6px;border:1px solid "
                      v-model="value2" type="daterange" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                      value-format="yyyyMMdd" range-separator="" class="border_box" start-placeholder="添加时间"
                      end-placeholder="结束时间" align="right" :class="{ 'your-css-class': !isValue2Empty }"
                      @change="selectImg()">
                    </el-date-picker>
                  </div>
                  <div class="all_input">
                    <span>修改时间</span>
                    <el-date-picker v-model="value1"
                      style="width: 180px;height: 40px; margin-left: 6px;border:1px solid " type="daterange"
                      :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                      class="border_box" start-placeholder="修改时间" end-placeholder="结束时间" align="right"
                      value-format="timestamp" :class="{ 'your-css-class': !isValue1Empty }" @change="selectImg()">
                    </el-date-picker>
                  </div>
                  <div class="all_input">
                    <span>下载时间</span>
                    <el-date-picker v-model="value3"
                      style="width: 180px;height: 40px; margin-left: 6px;border:1px solid " type="daterange"
                      :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                      class="border_box" start-placeholder="修改时间" end-placeholder="结束时间" align="right"
                      value-format="timestamp" :class="{ 'your-css-class': !isValue3Empty }" @change="selectImg()">
                    </el-date-picker>
                  </div>
                  <div class="all_input">
                    <span>查看时间</span>
                    <el-date-picker v-model="value4"
                      style="width: 180px;height: 40px; margin-left: 6px;border:1px solid " type="daterange"
                      :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                      class="border_box" start-placeholder="查看时间" align="right" end-placeholder="结束时间"
                      value-format="timestamp" :class="{ 'your-css-class': !isValue4Empty }" @change="selectImg()">
                    </el-date-picker>
                  </div>
                </div>
                <div>
                  <div class="all_input">
                    <span>尺寸</span>
                    <SizePopover :class="Object.keys(sizeRange_1).length ? 'orange' : 'blue'" ref="sizePopover2"
                      @save="handleSave" v-model="sizeRange_1" @clear="handleClear" />
                  </div>
                  <div>
                    <compress-size-input label="文件大小" placeholder="请输入范围" v-model="compressSize"
                      :class="compressSize == '' ? 'blue' : 'orange'" ref="compressPopover1"
                      @update="handleUpdate('compressSize', $event)"></compress-size-input>
                  </div>
                </div>
                <div>
                  <div class="all_input">
                    <span>保密</span>
                    <el-select v-model="baoMi" style="width:160px;height: 40px;" clearable @change="baoMi_e"
                      :class="baoMi == '' ? 'blue' : 'orange'">
                      <el-option v-for="(option, index) in options2" :key="index" :label="option.label"
                        :value="option.value" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="all_input">
                    <span>评分</span>
                    <el-select :class="pinFen == '' ? 'blue' : 'orange'" v-model="pinFen"
                      style="width:160px;height: 40px;" clearable @change="pinFen_e">
                      <el-option v-for="(option, index) in options3" :key="index" :label="option.label"
                        :value="option.value" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div>
                  <div>
                    <compress-size-input :class="xiazai_shu == '' ? 'blue' : 'orange'" v-model="xiazai_shu"
                      @update="handleUpdate('xiazai_shu', $event)" label="下载数量" ref="compressPopover3"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                  <div>
                    <compress-size-input :class="chaKan_shu == '' ? 'blue' : 'orange'" v-model="chaKan_shu"
                      @update="handleUpdate('chaKan_shu', $event)" label="查看数量" ref="compressPopover4"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                  <div>
                    <compress-size-input :class="shouCang == '' ? 'blue' : 'orange'" v-model="shouCang"
                      @update="handleUpdate('shouCang', $event)" label="收藏数量" ref="compressPopover4"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>

          <!-- 文件上传结束 -->
          <List v-if="changing == 3" :data="imgArr" :num="listNum" @Min_BOX="Min_BOX" ref="listComponent" />
        </div>
      </el-main>
    </el-container>
    <div v-if="$store.getters.coverShow == true" @click="coverEvt" class="cover_box"></div>
  </el-container>
</template>
<script>

import "../backHome/js/flex-images";
import {
  getVdtCodeApi,
  getLabelApi,
  changeImgApi,
  getImgLabelApi,
  stickLabelApi,
  singleLabelApi,
  fingerboardNumApi,
  spaceDataSubmitApi,
  showApi,
  CheckedApi,
  cloneEvtApi,
  showMenuApi,
  modeltagApi
} from "../apis/ces/a";
import { outLoginApi } from "../apis/loginApi";

import SpaceDialog_e from "../components/SpaceDialog_e.vue";
import SizePopover from "../components/SizePopover.vue";
import CompressSizeInput from '../components/CompressSizeInput.vue';

// import SearchLabel from "../components/searchLabel.vue";
import List from "@/components/list.vue";
import Upload from "../upload/index.vue";

const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

// 拼音声母可能的首字母
const PINYIN_INITIAL_CONSONANT_LETTERS = 'ABCDEFGHJKLMNOPQRSTWXYZ'.split('');
// 拼音声母对应的边界中文
const PINYIN_BOUNDARY_CHAR = '驁簿錯鵽樲鰒餜靃攟鬠纙鞪黁漚曝裠鶸蜶籜鶩鑂韻糳'.split('');
export default {
  components: {
    // SearchLabel,
    Upload,
    List,
    SpaceDialog_e,
    CompressSizeInput,
    SizePopover
  },
  data() {
    return {
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      a: 1,
      //头部默认数据
      activeIndex: "1",
      // 菜单默认打开
      openeds: ["1", "2", "3"],

      levelName: "请选择",
      sortName: "排序方式",
      uploadVisible: false,
      //查询数据
      checkInput: "",
      checkInputIs_tag: [],
      checkInputNot_tag: [],
      //序列前后数据
      behindOrderInput: "",
      frontOrderInput: "",
      //选择作者数据
      authorInput: "",
      //分页输入框数据
      paginationInput: null,
      //分页总数据
      total: null,
      //标签操作输入框数据
      operateLabelInput: "",
      //标签id
      labelId: "",
      //控制标签1 or 2请求
      labelAjax: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(
                current.valueOf() - (nowDayOfWeek - 1) * dayNum
              );
              const lastDate = new Date(
                new Date(firstDate).valueOf() + 6 * dayNum
              );
              picker.$emit("pick", [firstDate, lastDate]);
            }
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            }
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(
                new Date().getTime() - 60 * 60 * 24 * 7 * 1000
              );
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() -
                nowDayOfWeek +
                (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            }
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            }
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            }
          }
        ]
      },
      value2: "",
      input: "",
      //标签操作数据
      operateNum: {},
      // 滚动前，滚动条距文档顶部的距离
      oldScrollTop: 0,
      header: true,
      // 分页数据
      currentPage1: 1,
      //图片数据
      imgArr: [],
      // shift 案件数据
      shift: false,
      shiftFirst: false,
      //已选中图片数据
      selectArr: [],
      //空格弹窗
      dialogVisible: false,
      //空格弹窗标签数据
      spaceLabelArr: [],
      //空格弹窗当前页面数据
      spaceDialogNum: 0,
      //空格弹窗当前页面id
      spaceDialogId: [],
      //空格弹窗图片地址
      spaceSrc: "",
      //空格弹窗数据存储对象
      spaceObjData: {},
      //图片弹窗信息
      spaceImgInfo: {},
      //标签数据
      labelArr: [],
      //切换数据
      changing: sessionStorage.getItem('changing') || 1,
      //图片排版切换
      changingImg: false,
      //标签搜索弹窗数据
      searchLabelDialog: false,
      // 默认选中
      radio: ["1"],
      radioNum: ["1"],
      //右键弹窗数据
      rightLabelDialog: false,
      //弹出层
      operation: false,
      radio1: [""],
      operationArr: [],
      //当前页面状态
      process: 2,
      //图片左下弹窗显示状态
      visible: false,
      //搜索弹窗组件
      searchFor: false,
      //查看次数
      review: null,
      //收藏次数
      favorite: null,
      //排序数据
      sort: null,
      belongShow: null, //属于显示
      deleteVisible: false,
      deleteVisible_box: false,
      clone_box: false,
      loading: false,
      //空格弹窗图片数据（v之后）
      spaceWidth: "",
      spaceHeight: "",
      //空格弹窗图片数据（v之前）
      frontSpaceWidth: "",
      frontSpaceHeight: "",
      frontSpaceWidth1: "",
      frontSpaceHeight1: "",
      mousemoveId: "",
      selectAllText: "全选",
      selectAllBgColor: "#909399",
      pagefenye: false, //点击分页 滚动条为0
      num: null,
      listNum: null, //列表总数数据
      focusDiyIpt: false,
      orField: null,

      checkValue: false, //chenced的默认值
      xxm: false,
      currentLargeImage: null,
      currentPage: 1,
      imagesPerPage: 6,
      Deduplication: [],
      reviews: [],
      imagesToDelete: [], //图片储存对象
      imagesToDelete_box: [], //图片储存对象

      handleButtonSrc:
        "https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/x.png", // 初始handleButton的src
      correctButtonSrc:
        "https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/v.png ", // 初始correctButton的src
      clickedButton: null,
      clickedButtons: [], // 用于存储已点击过的按钮的 source_id
      allow: null,
      Check: 2,
      clicke: false,
      newParameters: [],
      c: 1,



      activeIndex_copy:0,
      menuItems: [],
      filterText: '',
      //新增的数据
      value1: '',  //修改时间
      value3: "",//下载时间
      value4: '', //查看时间
      compressSize: '',
      sizeRange_1: {},
      Maps_da: '',
      Maps_shu: '',
      object_shu: '',
      shuCai_shu: '',
      dingDian_shu: '',
      xiazai_shu: '',
      chaKan_shu: '',
      baoMi: '',
      pinFen: '',
      shouCang: '',


      selectedStars: 0, // 当前选中的星星数量
      filledStar: require('../img/星星.png'), // 已选中星星的图标
      emptyStar: require('../img/星星 (1).png'), // 未选中星星的图标
      anNiu: false,

      tags: [
        { name: '标签一' },
        { name: '标签二' },
        { name: '标签三' },
        { name: '标签四' },
        { name: '标签五' }
      ],
      design: '',
      options1: [
        {
          value: '1',
          label: '无线条',
        }, {
          value: '2',
          label: '有线条',
        }],
      options2: [
        {
          value: '1',
          label: '保密',
        }, {
          value: '2',
          label: '不保密',
        }, {
          value: '0',
          label: '未审核',
        }],
      options3: [{
        value: '0',
        label: '未评分',
      },
      {
        value: '1',
        label: '1',
      }, {
        value: '2',
        label: '2',
      }, {
        value: '3',
        label: '3',
      }, {
        value: '4',
        label: '4',
      }, {
        value: '5',
        label: '5',
      }],



      sizeRange: '',

      isDropdownVisible: false, // 控制下拉菜单的显示与隐藏
      currentImageSrc: require("@/img/2.png"), // 默认显示的图片
      images: [
        { num: 1, src: require("@/img/2.png") },
        { num: 2, src: require("@/img/3.png") },
        { num: 3, src: require("@/img/6.png") }
      ],
      selectedNode: null, // 存储当前选中的节点

      isValue2Empty: true,
      isValue1Empty: true,
      isValue3Empty: true,
      isValue4Empty: true,
      dialogVisible_one: false,
    };
  },
  computed: {

    coverShow() {
      return this.$store.getters.coverShow;
    },
    contractNum() {
      return this.$store.getters.contractNum;
    },
    isCheckedValue() {
      return this.$store.state.CheckedValue;
    },
    // 根据当前页和每页数量计算要展示的图片数组 111
    currentImages() {
      if (this.Deduplication && this.Deduplication.length > 0) {
        const startIndex = (this.currentPage - 1) * this.imagesPerPage;
        const endIndex = startIndex + this.imagesPerPage;

        return this.Deduplication.slice(startIndex, endIndex);
      } else {
        return []; // 返回一个空数组
      }
    },

    totalPages() {
      if (this.Deduplication && this.Deduplication.length > 0) {
        return Math.ceil(this.Deduplication.length / this.imagesPerPage);
      } else {
        return 0; // 没有图片时返回 0
      }
    },


    setSwitch: {
      get() {
        return this.$store.getters.setSwitch;
      },
      c: {
        get() {
          return this.$store.getters.location;
        },
      }
    },
    // 计算当前选中的图片路径

  },
  created() {
    showMenuApi({ c: this.c }).then((res) => {
      if (res.code == 1000) {
        this.$store.dispatch("setContractNum", res.data.open);
      }
    });

    this.$store.commit('setCheckedValue', false);
    if (this.$store.getters.location == '') {
      this.c = 1
    }

    var arr = JSON.parse(JSON.stringify(this.$store.getters.menuList)).splice(
      0,
      1
    );
    this.operationArr = arr.map(res => {
      res.selectArr = [`${res.id}_${this.process}`];
      return res;
    });
    // this.operationArr[0].selectArr[0].slice(-1)
    if (this.checkValue == true) {
      let grounding = JSON.parse(sessionStorage.getItem("grounding"));
      if (grounding) {
        this.authorInput = grounding.select.author;
        (this.value2 = grounding.select.time),
          (this.checkInput = grounding.select.checkInput);
        this.radio = grounding.select.radio;
        this.frontOrderInput = grounding.select.source_id;
        this.sort = grounding.select.sort;
        switch (grounding.select.sort) {
          case "8":
            this.sortName = "点击查看次数最多";
            break;
          case "9":
            this.sortName = "收藏最多";
            break;
          case "1":
            this.sortName = "上传时间-升序";

            break;
          case "2":
            this.sortName = "上传时间-降序";

            break;
          case "3":
            this.sortName = "文件大小-升序";

            break;
          case "4":
            this.sortName = "文件大小-降序";

            break;
          case "5":
            this.sortName = "文件尺寸-升序";

            break;
          case "6":
            this.sortName = "文件尺寸-降序";

            break;
          case "7":
            this.sortName = "下载次数最多";

            break;
        }
        getVdtCodeApi({
          process: this.process,
          is_tag: grounding.select.is_tag,
          not_tag: grounding.select.not_tag,
          author: grounding.select.author,
          time: grounding.select.time,
          tag_type: grounding.select.radio[0],
          tag_id: grounding.select.labelId,
          source_id: grounding.select.source_id,
          sort: grounding.select.sort,
          type: this.adminuser,
          dup: this.Check,
          c: this.c
        }).then(res => {
          if (res.code == 1000) {
            this.imgArr = res.data.data;
            this.total = res.data.total;
            this.paginationInput = res.data.limit;
            this.changing = res.data.show;
            this.sort = res.data.sort;
            this.operateNum.all = res.data.total;
            this.listNum = {
              download_num: res.data.download_num,
              review: res.data.review,
              favorite: res.data.favorite,
              total: res.data.total
            };
            if (grounding.select.labelId) {
              this.labelId = grounding.select.labelId;
              this.operateLabelInput = grounding.select.operateLabelInput;

              getVdtCodeApi({
                is_tag: grounding.select.is_tag,
                not_tag: grounding.select.not_tag,
                source_id: grounding.select.source_id,
                author: grounding.select.author,
                time: grounding.select.time,
                tag_id: grounding.select.labelId,
                process: this.process,
                type: this.adminuser,
                c: this.c
              }).then(val => {
                if (res.code == 1000) {
                  this.operateNum.show = true;
                  this.operateNum.all = res.data.total;
                  this.operateNum.belong = res.data.belong;
                  this.operateNum.not_belong = res.data.not_belong;
                  this.operateNum.not_review = res.data.not_review;
                  this.imgArr = res.data.data;
                  this.listNum = {
                    download_num: res.data.download_num,
                    review: res.data.review,
                    favorite: res.data.favorite,
                    total: res.data.total
                  };
                  let arr = [];
                  this.imgArr.map(v => {
                    res.data.data.map(l => {
                      if (v.source_id == l.source_id) {
                        v.status = l.status;
                        arr.push(v);
                      }
                    });
                  });
                  this.imgArr = arr;
                }
              });
            }
          }
        });
      } else {
        getVdtCodeApi({
          process: this.process,
          c: this.c

        }).then(res => {
          if (res.code == 1000) {
            this.imgArr = res.data.data;
            this.total = res.data.total;
            this.paginationInput = res.data.limit;
            this.changing = res.data.show;
            this.sort = res.data.sort;
            this.operateNum.all = res.data.total;
            this.listNum = {
              download_num: res.data.download_num,
              review: res.data.review,
              favorite: res.data.favorite,
              total: res.data.total
            };
          }
        });
      }
    } else {
      let grounding = JSON.parse(sessionStorage.getItem("grounding"));
      if (grounding) {
        this.authorInput = grounding.select.author;
        (this.value2 = grounding.select.time),
          (this.checkInput = grounding.select.checkInput);
        this.radio = grounding.select.radio;
        this.frontOrderInput = grounding.select.source_id;
        this.sort = grounding.select.sort;
        switch (grounding.select.sort) {
          case "8":
            this.sortName = "点击查看次数最多";
            break;
          case "9":
            this.sortName = "收藏最多";
            break;
          case "1":
            this.sortName = "上传时间-升序";

            break;
          case "2":
            this.sortName = "上传时间-降序";

            break;
          case "3":
            this.sortName = "文件大小-升序";

            break;
          case "4":
            this.sortName = "文件大小-降序";

            break;
          case "5":
            this.sortName = "文件尺寸-升序";

            break;
          case "6":
            this.sortName = "文件尺寸-降序";

            break;
          case "7":
            this.sortName = "下载次数最多";

            break;
        }
        getVdtCodeApi({
          process: this.process,
          is_tag: grounding.select.is_tag,
          not_tag: grounding.select.not_tag,
          author: grounding.select.author,
          time: grounding.select.time,
          tag_type: grounding.select.radio[0],
          tag_id: grounding.select.labelId,
          source_id: grounding.select.source_id,
          sort: grounding.select.sort,
          type: this.adminuser,
          c: this.c
        }).then(res => {
          if (res.code == 1000) {
            this.imgArr = res.data.data;
            this.total = res.data.total;
            this.paginationInput = res.data.limit;
            this.changing = res.data.show;
            this.sort = res.data.sort;
            this.operateNum.all = res.data.total;
            this.listNum = {
              download_num: res.data.download_num,
              review: res.data.review,
              favorite: res.data.favorite,
              total: res.data.total
            };
            if (grounding.select.labelId) {
              this.labelId = grounding.select.labelId;
              this.operateLabelInput = grounding.select.operateLabelInput;

              getVdtCodeApi({
                is_tag: grounding.select.is_tag,
                not_tag: grounding.select.not_tag,
                source_id: grounding.select.source_id,
                author: grounding.select.author,
                time: grounding.select.time,
                tag_id: grounding.select.labelId,
                process: this.process,
                type: this.adminuser,
                c: this.c
              }).then(val => {
                if (res.code == 1000) {
                  this.operateNum.show = true;
                  this.operateNum.all = res.data.total;
                  this.operateNum.belong = res.data.belong;
                  this.operateNum.not_belong = res.data.not_belong;
                  this.operateNum.not_review = res.data.not_review;
                  this.imgArr = res.data.data;
                  this.listNum = {
                    download_num: res.data.download_num,
                    review: res.data.review,
                    favorite: res.data.favorite,
                    total: res.data.total
                  };
                  let arr = [];
                  this.imgArr.map(v => {
                    res.data.data.map(l => {
                      if (v.source_id == l.source_id) {
                        v.status = l.status;
                        arr.push(v);
                      }
                    });
                  });
                  this.imgArr = arr;
                }
              });
            }
          }
        });
      } else {
        getVdtCodeApi({
          process: this.process,
          c: this.c
        }).then(res => {
          if (res.code == 1000) {
            this.imgArr = res.data.data;
            this.total = res.data.total;
            this.paginationInput = res.data.limit;
            this.changing = res.data.show;
            this.sort = res.data.sort;
            this.operateNum.all = res.data.total;
            this.listNum = {
              download_num: res.data.download_num,
              review: res.data.review,
              favorite: res.data.favorite,
              total: res.data.total
            };
          }
        });
      }
    }
    //监听鼠标按下抬起事件
    window.addEventListener("keydown", this.handKeyCode, true);
    window.addEventListener("keyup", this.handKeyEvt, true);
    this.$store.dispatch("setMenuList", this.menuList);




    setTimeout(() => {
      modeltagApi().then((res) => {
        this.menuItems = this.transformToTree(res.data)
      });
    }, 300)
    let chang = sessionStorage.getItem('changing') || 1;
    if (chang) {
      // 根据 changing 的值更新 currentImageSrc
      const selectedImage = this.images.find(image => image.num == this.changing);
      if (selectedImage) {
        this.changing = selectedImage.num
        this.currentImageSrc = selectedImage.src;
      }
    }
  },
  mounted() {
    const location = this.$store.getters.location;
    //监听页面滚动条事件
    window.addEventListener("scroll", e => this.imgScrollEvt(e), true);
    this.c = this.$store.getters.location;
    window.addEventListener('click', this.hideDropdownIfClickedOutside);

  },
  updated() {
    this.$nextTick(() => {
      new flexImages({
        selector: ".flex-images",
        rowHeight: 280
      });
    });
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);
    window.removeEventListener('click', this.hideDropdownIfClickedOutside);

  },

  watch: {
    '$store.getters.location': function (newLocation, oldLocation) {
      this.c = newLocation
    },

    //修改选中日期的背景颜色
    value2: function (newVal, oldVal) {
      this.isValue2Empty = !newVal;
    },
    coverShow(newV, oldV) {
      if (newV == false) {
        this.imgArr = this.imgArr.map(res => {
          res.leftSelect = false;
          return res;
        });
      }
    },
    contractNum(n, v) {
      if (n) {
        this.$nextTick(() => {
          new flexImages({
            selector: ".flex-images",
            rowHeight: 280
          });
        });
      }
    },

    isCheckedValue(m, s) {
      //checked的值 为ture还是false
      this.checkValue = m;
      if (this.checkValue == true) {
        this.Check = 1;
        let grounding = JSON.parse(sessionStorage.getItem("grounding"));
        if (grounding) {
          this.authorInput = grounding.select.author;
          (this.value2 = grounding.select.time),
            (this.checkInput = grounding.select.checkInput);
          this.radio = grounding.select.radio;
          this.frontOrderInput = grounding.select.source_id;
          this.sort = grounding.select.sort;
          switch (grounding.select.sort) {
            case "8":
              this.sortName = "点击查看次数最多";
              break;
            case "9":
              this.sortName = "收藏最多";
              break;
            case "1":
              this.sortName = "上传时间-升序";

              break;
            case "2":
              this.sortName = "上传时间-降序";

              break;
            case "3":
              this.sortName = "文件大小-升序";

              break;
            case "4":
              this.sortName = "文件大小-降序";

              break;
            case "5":
              this.sortName = "文件尺寸-升序";

              break;
            case "6":
              this.sortName = "文件尺寸-降序";

              break;
            case "7":
              this.sortName = "下载次数最多";

              break;
          }
          getVdtCodeApi({
            process: this.process,
            is_tag: grounding.select.is_tag,
            not_tag: grounding.select.not_tag,
            author: grounding.select.author,
            time: grounding.select.time,
            tag_type: grounding.select.radio[0],
            tag_id: grounding.select.labelId,
            source_id: grounding.select.source_id,
            sort: grounding.select.sort,
            type: this.adminuser,
            dup: this.Check,
            c: this.c
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total
              };
              if (grounding.select.labelId) {
                this.labelId = grounding.select.labelId;
                this.operateLabelInput = grounding.select.operateLabelInput;

                getVdtCodeApi({
                  is_tag: grounding.select.is_tag,
                  not_tag: grounding.select.not_tag,
                  source_id: grounding.select.source_id,
                  author: grounding.select.author,
                  time: grounding.select.time,
                  tag_id: grounding.select.labelId,
                  process: this.process,
                  type: this.adminuser,
                  dup: this.Check,
                  c: this.c,
                }).then(val => {
                  if (res.code == 1000) {
                    this.operateNum.show = true;
                    this.operateNum.all = res.data.total;
                    this.operateNum.belong = res.data.belong;
                    this.operateNum.not_belong = res.data.not_belong;
                    this.operateNum.not_review = res.data.not_review;
                    this.imgArr = res.data.data;
                    this.listNum = {
                      download_num: res.data.download_num,
                      review: res.data.review,
                      favorite: res.data.favorite,
                      total: res.data.total
                    };
                    let arr = [];
                    this.imgArr.map(v => {
                      res.data.data.map(l => {
                        if (v.source_id == l.source_id) {
                          v.status = l.status;
                          arr.push(v);
                        }
                      });
                    });
                    this.imgArr = arr;
                  }
                });
              }
            }
          });
        } else {
          getVdtCodeApi({
            process: this.process,
            dup: this.Check,
            c: this.c,
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total
              };
            }
          });
        }
      } else {
        this.Check = 2;
        let grounding = JSON.parse(sessionStorage.getItem("grounding"));
        if (grounding) {
          this.authorInput = grounding.select.author;
          (this.value2 = grounding.select.time),
            (this.checkInput = grounding.select.checkInput);
          this.radio = grounding.select.radio;
          this.frontOrderInput = grounding.select.source_id;
          this.sort = grounding.select.sort;
          switch (grounding.select.sort) {
            case "8":
              this.sortName = "点击查看次数最多";
              break;
            case "9":
              this.sortName = "收藏最多";
              break;
            case "1":
              this.sortName = "上传时间-升序";

              break;
            case "2":
              this.sortName = "上传时间-降序";

              break;
            case "3":
              this.sortName = "文件大小-升序";

              break;
            case "4":
              this.sortName = "文件大小-降序";

              break;
            case "5":
              this.sortName = "文件尺寸-升序";

              break;
            case "6":
              this.sortName = "文件尺寸-降序";

              break;
            case "7":
              this.sortName = "下载次数最多";

              break;
          }
          getVdtCodeApi({
            process: this.process,
            is_tag: grounding.select.is_tag,
            not_tag: grounding.select.not_tag,
            author: grounding.select.author,
            time: grounding.select.time,
            tag_type: grounding.select.radio[0],
            tag_id: grounding.select.labelId,
            source_id: grounding.select.source_id,
            sort: grounding.select.sort,
            type: this.adminuser,
            c: this.c,
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total
              };
              if (grounding.select.labelId) {
                this.labelId = grounding.select.labelId;
                this.operateLabelInput = grounding.select.operateLabelInput;

                getVdtCodeApi({
                  is_tag: grounding.select.is_tag,
                  not_tag: grounding.select.not_tag,
                  source_id: grounding.select.source_id,
                  author: grounding.select.author,
                  time: grounding.select.time,
                  tag_id: grounding.select.labelId,
                  process: this.process,
                  type: this.adminuser,
                  c: this.c,
                }).then(val => {
                  if (res.code == 1000) {
                    this.operateNum.show = true;
                    this.operateNum.all = res.data.total;
                    this.operateNum.belong = res.data.belong;
                    this.operateNum.not_belong = res.data.not_belong;
                    this.operateNum.not_review = res.data.not_review;
                    this.imgArr = res.data.data;
                    this.listNum = {
                      download_num: res.data.download_num,
                      review: res.data.review,
                      favorite: res.data.favorite,
                      total: res.data.total
                    };
                    let arr = [];
                    this.imgArr.map(v => {
                      res.data.data.map(l => {
                        if (v.source_id == l.source_id) {
                          v.status = l.status;
                          arr.push(v);
                        }
                      });
                    });
                    this.imgArr = arr;
                  }
                });
              }
            }
          });
        } else {
          getVdtCodeApi({
            process: this.process,
            c: this.c,

          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total,
              };
            }
          });
        }
      }
    }
  },
  methods: {
    handleSave(dimensions) {
      this.sizeRange_1 = dimensions; // 使用扩展运算符确保响应式
      this.selectImg();
    },
    handleClear() {
      this.sizeRange_1 = {}; // 清空 sizeRange_1
      this.selectImg();
    },
    type_one(selectedValues) {
      this.design = selectedValues;

      this.selectImg();
    },
    baoMi_e(val) {
      this.baoMi = val;
      this.selectImg();
    },
    pinFen_e(val) {
      this.pinFen = val;
      this.selectImg();
    },





    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible; // 切换下拉菜单的显示状态
    },
    selectImage(image) {
      let _this = this;
      _this.changing = image.num; // 更新 changing 状态

      sessionStorage.setItem('changing', image.num); // 将 changing 存入 sessionStorage
      _this.currentImageSrc = image.src; // 更新 currentImageSrc
      _this.isDropdownVisible = false; // 隐藏下拉菜单
      // 调用 changingEvt 方法
      _this.changingEvt(image.num);
    },
    hideDropdownIfClickedOutside(event) {
      // 检查点击是否发生在 dropdown-container 或其子元素之外
      const dropdownContainer = document.querySelector('.dropdown-container');
      if (dropdownContainer && !dropdownContainer.contains(event.target)) {
        this.isDropdownVisible = false;
      }
    },
    handleUpdate(key, value) {
      console.log(this.parseSizeRange(this.compressSize),21212);

      console.log(`Parent received update for ${key}:`, value);
      // 更新当前组件的状态前打印旧值
      console.log(`${key} old value:`, this[key]);
      // 更新当前组件的状态
      this[key] = value;
      // 打印新值以确认更新成功
      console.log(`${key} new value:`, this[key]);

      // 更新当前组件的状态
      this[key] = value;
      // 动态构造请求参数
      const params = {
        orField: this.orField,
        orWhere: this.orWhere,
        time: this.value2,
        tag_type: this.radio[0],
        source_id: this.frontOrderInput,
        behindOrder: this.behindOrderInput,


        c: this.c,
        process: this.process,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,

        tag_id: this.labelId,
        type: this.adminuser,
        dup: this.Check,

        compressSize: this.parseSizeRange(this.compressSize),
        sizeRange_1: this.sizeRange_1,
        xiazai_shu: this.parseSizeRange(this.xiazai_shu),
        chaKan_shu: this.parseSizeRange(this.chaKan_shu),
        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,
        design: this.design,
        baoMi: this.baoMi,
        pinFen: this.pinFen,
        shouCang: this.parseSizeRange(this.shouCang),

      };
      console.log(this.parseSizeRange(this.compressSize),555);


      // 如果 selectedNode.id 存在，则添加 id 参数
      if (this.selectedNode && this.selectedNode.id) {
        params.id = this.selectedNode.id;
      }
      // 调用接口
      getVdtCodeApi(params).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total,
          };
        }
      });
    },

    // 解析大小范围的辅助函数
    parseSizeRange(sizeValue) {
      if (Array.isArray(sizeValue)) {
        return sizeValue;
      }
      if (typeof sizeValue === 'string') {
        // 清理输入中的多余空格
        sizeValue = sizeValue.trim();

        // 特别针对 "1111 - MB" 格式的输入
        const rangeWithUnitMatch = sizeValue.match(/^(\d+)\s*-\s*(\w+)$/);
        if (rangeWithUnitMatch) {
          const number = parseInt(rangeWithUnitMatch[1], 10);
          const unit = rangeWithUnitMatch[2];
          return [`${number}`, '', unit]; // 返回 [数值, 空字符串, 单位]
        }

        // 支持单边范围, 如 "111 -" 或 "- 15"
        const regexSingle = /^(\d+)\s*-\s*$|^-\s*(\d+)(?:\s+(\w+))?$/;
        let match = sizeValue.match(regexSingle);
        if (match) {
          const unit = match[3] || ''; // 不再默认为'KB'
          if (match[1]) { // 表示最小值
            const singleNumber = parseInt(match[1], 10);
            return [`${singleNumber}`, '', unit];
          } else if (match[2]) { // 表示最大值
            const singleNumber = parseInt(match[2], 10);
            return ['', `${singleNumber}`, unit];
          }
        }

        // 检查是否是简单的数字输入（例如 "111" 或 "111 KB"）
        const singleNumberMatch = sizeValue.match(/^(\d+)(?:\s+(\w+))?$/);
        if (singleNumberMatch) {
          const number = parseInt(singleNumberMatch[1], 10);
          const unit = singleNumberMatch[2] || ''; // 不再默认为'KB'
          return [`${number}`, '', unit];
        }

        // 原有的多条件匹配逻辑...
        const regex = /^(\d+)\s*([<>=])\s*(\d+)(?:\s+(\w+))?$/;
        match = sizeValue.match(regex);

        if (match) {
          const [_, num1, operator, num2, unit] = match;
          const parsedNum1 = parseInt(num1, 10);
          const parsedNum2 = parseInt(num2, 10);

          if (operator === '=') {
            if (parsedNum1 !== parsedNum2) {
              console.warn('Invalid input: Numbers on both sides of "=" must be equal.');
              return null;
            }
            return [`${parsedNum1}`, `${parsedNum1}`, unit || '']; // 如果没有单位，则为空字符串
          } else {
            const min = Math.min(parsedNum1, parsedNum2);
            const max = Math.max(parsedNum1, parsedNum2);
            return [`${min}`, `${max}`, unit || '']; // 如果没有单位，则为空字符串
          }
        }
      }

      const singleNumber = parseInt(sizeValue, 10);
      if (!isNaN(singleNumber)) {
        return [`${singleNumber}`, '', '']; // 不再默认为'KB', 第二个值为空字符串
      }
      return ['', '', '']; // 如果无法解析，返回两个空字符串和空的单位
    },


    handleCurrentChange_evt(currentNode) {
      // 当前选中节点变化时的处理逻辑
      this.selectedNode = currentNode;
      let params = {
        orField: this.orField,
        orWhere: this.orWhere,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        time: this.value2,
        tag_type: this.radio[0],
        source_id: this.frontOrderInput,

        tag_id: this.labelId,
        type: this.adminuser,
        dup: this.Check,
        c: this.c,
        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,
        design: this.design,
        baoMi: this.baoMi,
        pinFen: this.pinFen,
        shouCang: this.parseSizeRange(this.shouCang),
        author: this.authorInput,


        compressSize: this.parseSizeRange(this.compressSize),
        sizeRange_1: this.sizeRange_1,

      };
      if (this.selectedNode.id !== "all") {
         params.author_id = this.selectedNode.id;
      }

      getVdtCodeApi(params).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total,
          };
        }
      });
    },


    getChinesePinyinAbbreviation(str) {
      if (!str) return '';
      if (str.length > 1) {
        return str.split('').map(char => this.getChinesePinyinAbbreviation(char)).join('');
      }
      if (/[^\u4e00-\u9fa5]/.test(str)) {
        return str.toUpperCase();
      }
      const index = PINYIN_BOUNDARY_CHAR.findIndex((char) => {
        return char.localeCompare(str, 'zh-CN-u-co-pinyin') >= 0;
      });
      return PINYIN_INITIAL_CONSONANT_LETTERS[Math.max(0, index)];
    },

    transformToTree(data) {
      const map = {};
      let totalNum = 0;

      data.author.forEach(item => {
        // 过滤掉 username 为空或以 '0' 开头的项
        if (!item.username || item.username.startsWith('0')) return;

        const node = {
          id: item.id,
          name: item.username,
          num: item.num || 0,
          children: []
        };
        map[item.id] = node;
        totalNum += node.num;
      });

      const tree = Object.values(map);

      tree.sort((a, b) => {
        const aFirstLetter = this.getChinesePinyinAbbreviation(a.name)[0] || '#';
        const bFirstLetter = this.getChinesePinyinAbbreviation(b.name)[0] || '#';
        return aFirstLetter.localeCompare(bFirstLetter, undefined, { sensitivity: 'base' });
      });

      const allNode = {
        id: 'all',
        name: '全部',
        num: totalNum,
        children: []
      };

      return [allNode, ...tree];
    },




    filterNode(value, data) {
      if (!value) return true; // 如果没有搜索值，返回 true 表示不过滤
      return data.name && data.name.indexOf(value) !== -1; // 根据 name 进行过滤
    },
    onFilter() {
      this.$refs.tree.filter(this.filterText);
      // 如果输入框内容为空，则重置树的状态
      if (!this.filterText) {
        this.resetTreeState();
      }
    },
    resetTreeState() {
      const allNodes = this.$refs.tree.store._getAllNodes();
      allNodes.forEach(node => {
        if (!node.isLeaf) {
          node.expanded = false; // 手动设置节点为折叠状态
        }
      });

      // 清除当前选中的节点（如果需要）
      this.$refs.tree.setCurrentKey(null);
    },

    clone_s() {
      this.dialogVisible = false
      this.dataTab = []
      this.dataOne = []
      this.tags = []
    },


    //去重页面左侧弹窗出现后点击确认删除图片
    delete_box() {
      this.clicke = true
      // 检查是否已经存在与 this.spaceDialogId[0] 匹配的数据
      const existingDataIndex = this.imagesToDelete_box.findIndex(item => {
        return item.source_id === this.spaceDialogId[0];
      });
      if (existingDataIndex === -1) {
        // 如果不存在，则添加新的数据
        const dataToSend = {
          source_id: this.spaceDialogId[0],
          dup_source_id: this.spaceDialogId[0],
          allow: 2,
        };
        this.imagesToDelete_box.push(dataToSend);
      }
    },

    //点击X 删除图片
    handleButtonClick(index, $event, oriImage) {
      var OriImage = oriImage;
      let clickedButton = $event.target;
      const dup_source_id = OriImage.source_id; // 获取dup_source_id

      // 恢复另一个按钮的样式为默认
      const otherButtonIndex = index === 1 ? 2 : 1;
      const otherButton = document.getElementById(
        dup_source_id + (otherButtonIndex === 1 ? "x" : "v")
      );
      otherButton.src =
        "https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/" +
        (otherButtonIndex === 1 ? "x" : "v") +
        ".png";

      let deleteObject = {
        source_id: this.spaceDialogId[0],
        dup_source_id: dup_source_id // 使用获取到的dup_source_id
      };

      // 检查是否存在相同的 dup_source_id，如果存在则移除旧的信息
      const existingIndex = this.imagesToDelete_box.findIndex(
        item => item.dup_source_id === deleteObject.dup_source_id
      );
      if (existingIndex !== -1) {
        this.imagesToDelete_box.splice(existingIndex, 1);
      }

      let newArr = [];
      newArr = this.imagesToDelete.filter(img => {
        return (
          img.source_id !== deleteObject.source_id ||
          img.dup_source_id !== deleteObject.dup_source_id
        );
      });
      this.imagesToDelete = newArr;

      // 将点击的按钮信息添加到数组
      this.imagesToDelete_box.push(deleteObject);
      // 假设你在分页操作中进行了检查，然后根据条件来更新img的src属性
      this.Deduplication.forEach(res => {
        this.imagesToDelete_box.map(val => {
          if (res.source_id === val.dup_source_id) {
            if (index === 1) {
              clickedButton.src =
                "https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/x2.png";
              deleteObject.allow = 2;
              document.getElementById(
                dup_source_id + "x"
              ).src = this.correctButtonSrc;
            } else {
              clickedButton.src =
                "https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/v2.png";
              deleteObject.allow = 1;
              document.getElementById(
                dup_source_id + "v"
              ).src = this.handleButtonSrc;
            }
          }
        });
      });
      // 检查是否存在相同的 dup_source_id，如果存在则移除旧的信息
      const existingClickedIndex = this.clickedButtons.findIndex(
        button => button.dup_source_id === dup_source_id // 使用获取到的dup_source_id
      );
      if (existingClickedIndex !== -1) {
        this.clickedButtons.splice(existingClickedIndex, 1);
      }

      this.clickedButtons.push({
        source_id: deleteObject.source_id, // 使用deleteObject中的source_id
        dup_source_id: dup_source_id // 使用获取到的dup_source_id
      });
    },

    nextPage() {
      if (this.currentLargeImage) {
        return;
      }
      if (this.currentPage < this.totalPages) {
        // 更新 currentPage
        this.currentPage++;
      }
    },

    prevPage() {
      if (this.currentLargeImage) {
        return;
      }
      if (this.currentPage > 1) {
        // 更新 currentPage
        this.currentPage--;
      }
    },

    showLargeImage(image, index) {
      // 如果当前已经有大图显示，点击大图时隐藏大图并返回小图
      if (this.currentLargeImage) {
        this.currentLargeImage.style.display = "none"; // 隐藏大图
        this.currentLargeImage = null; // 清空当前大图信息
        this.currentLargeImage.remove();
        this.restoreSmallImages(); // 恢复小图和按钮显示
        return;
      }
      // 创建新的大图元素
      const largeImage = document.createElement("img");
      largeImage.classList.add("large-image");
      largeImage.src = image.review;
      largeImage.id = image.source_id;
      largeImage.alt = "Large Image";
      largeImage.style.width = "800px";
      largeImage.style.height = "auto";
      largeImage.style.maxHeight = "850px";
      largeImage.style.objectFit = "contain";
      largeImage.style.background = "#d1d1d1";
      // 创建按钮元素
      const button1 = document.createElement("span");
      button1.style.position = "absolute";
      button1.style.bottom = "10px";
      button1.style.right = "135px";

      // 创建img1元素，设置其src属性
      const img1 = document.createElement("img");
      img1.src =
        "https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/x.png"; // 替换为第一个图像的路径
      img1.alt = "Image 1"; // 替换为适当的图像描述
      img1.style.width = "20px";
      img1.style.height = "20px";
      button1.style.cursor = "pointer";

      button1.appendChild(img1); // 将img1添加到button1中
      const button2 = document.createElement("span");

      // 将按钮2的内容更改为图像
      button2.style.position = "absolute";
      button2.style.bottom = "10px";
      button2.style.right = "65px";
      button2.style.cursor = "pointer";
      // 创建img2元素，设置其src属性
      const img2 = document.createElement("img");
      img2.src =
        "https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/v.png"; // 替换为第二个图像的路径
      img2.alt = "Image"; // 替换为适当的图像描述
      img2.style.width = "20px";
      img2.style.height = "20px";
      button2.appendChild(img2); // 将img2添加到button2中
      const spaceDialogIdValue = this.spaceDialogId[0];
      button1.addEventListener("click", () => {
        // 在这里添加按钮1的点击事件处理逻辑
        cloneEvtApi({
          source_id: spaceDialogIdValue,
          dup_source_id: image.source_id,
          allow: 2,
          c: this.c,
        }).then(res => {
          if (res.code == 1000) {
            // 查找所有与image.source_id相等的索引
            const indexesToRemove = this.currentImages.reduce(
              (acc, curr, index) => {
                if (curr.source_id === image.source_id) {
                  acc.push(index);
                }
                return acc;
              },
              []
            );
            // 删除所有匹配的图片
            indexesToRemove.reverse().forEach(index => {
              this.currentImages.splice(index, 1);
              this.$forceUpdate(); // 手动触发重新渲染
            });
            // 清空当前大图信息
            if (image.source_id == largeImage.id) {
              this.currentLargeImage.style.display = "none"; // 隐藏大图
              this.currentLargeImage = null; // 清空当前大图信息
            }
            // 恢复小图和按钮显示
            this.restoreSmallImages();
          }
        });
      });
      button2.addEventListener("click", function () {
        // 在这里添加按钮2的点击事件处理逻辑
        cloneEvtApi({
          source_id: spaceDialogIdValue,
          dup_source_id: image.source_id,
          allow: 1,
          c: this.c,
        }).then(res => {
          if (res.code == 1000) {
            // 查找所有与image.source_id相等的索引
            const indexesToRemove = this.currentImages.reduce(
              (acc, curr, index) => {
                if (curr.source_id === image.source_id) {
                  acc.push(index);
                }
                return acc;
              },
              []
            );
            // 删除所有匹配的图片
            indexesToRemove.reverse().forEach(index => {
              this.currentImages.splice(index, 1);
              this.$forceUpdate(); // 手动触发重新渲染
            });
            // 清空当前大图信息
            if (image.source_id == largeImage.id) {
              this.currentLargeImage.style.display = "none"; // 隐藏大图
              this.currentLargeImage = null; // 清空当前大图信息
            }
            // 恢复小图和按钮显示
            this.restoreSmallImages();
          }
        });
      });
      // 显示按钮1和按钮2
      button1.style.display = "none";
      button2.style.display = "none";

      // 获取所有小图像元素和按钮元素
      const smallImages = document.querySelectorAll(".small-image");
      const buttons = document.querySelectorAll("btn");
      const button_container = document.querySelectorAll(".button-container");
      // 隐藏所有小图像和按钮
      smallImages.forEach(smallImage => {
        smallImage.style.display = "none";
      });
      buttons.forEach(button => {
        button.style.display = "none";
      });
      button_container.forEach(res => {
        res.style.display = "none";
      });

      // 将大图和按钮插入到image-container中
      const imageContainer = document.getElementById("image-container");
      imageContainer.appendChild(largeImage);
      imageContainer.appendChild(button1);
      imageContainer.appendChild(button2);

      // 更新当前大图信息
      this.currentLargeImage = largeImage;
      // 为大图添加点击事件处理程序，以隐藏大图
      largeImage.addEventListener("click", () => {
        largeImage.style.display = "none"; // 隐藏大图
        this.restoreSmallImages(); // 恢复小图和按钮显示
        this.currentLargeImage = null; // 清空当前大图信息
        button1.style.display = "none"; // 隐藏按钮1
        button2.style.display = "none"; // 隐藏按钮2
        this.currentLargeImage = null; // 清空当前大图信息
      });
    },
    constructor() {
      // 其他构造逻辑
      // 绑定函数的上下文
      this.restoreSmallImages = this.restoreSmallImages.bind(this);
    },

    restoreSmallImages() {
      // 获取所有小图像元素和按钮元素
      const smallImages = document.querySelectorAll(".small-image");
      const button_container = document.querySelectorAll(".button-container");
      // // 恢复小图和按钮显示
      smallImages.forEach(smallImage => {
        smallImage.style.display = "block";
      });
      button_container.forEach(res => {
        res.style.display = "block";
        res.style.display = "flex";
      });
    },

    //等级
    levelEvt(res) {
      switch (res) {
        case "1":
          this.levelName = "真实用户";
          break;
        case "2":
          this.levelName = "内部上传";
          break;
      }
      this.adminuser = res;
      this.selectImg();
    },

    //将排序参数传递给子组件
    Min_BOX(props) {
      this.orField = props.orWhere;
      (this.orWhere = props.order), this.selectImg();
    },
    //分页只显示前三页加总数
    showTotal(total) {
      return `共 ${total} 页`;
    },
    //键盘抬起事件
    handKeyEvt(e) {
      e = e || window.event;
      if (e.keyCode == 16) {
        this.shift = false;
        this.shiftFirst = false;
      }
    },
    //按下键盘事件
    handKeyCode(e) {
      if (this.uploadVisible == true) {
        return;
      }
      if (this.focusDiyIpt == true) {
        return;
      }
      // 如果事件目标是输入框，则直接返回，不执行任何逻辑
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        return;
      }
      e = e || window.event;
      if (this.imgArr.filter(res => res.select == true).length !== 0) {
        //空格空格事件
        if (e.keyCode == 32) {
          this.dialogVisible = true;
          e.preventDefault();
        }
        // 键盘左键事件
        if (e.keyCode == 37) {
          if (this.spaceDialogNum == 1) {
            return;
          }

          e.preventDefault();
          this.spaceDialogNum -= 2;
          this.spaceDialogEvt();
          if (this.checkValue == true) {
            this.spaceDialogEvt1();
            this.btns();
            this.LeftEv()
            return;
          }
        }

        //键盘右键事件
        if (e.keyCode == 39) {
          if (this.spaceDialogNum == this.selectArr.length) {
            return;
          }
          if (this.checkValue == true) {
            this.spaceDialogEvt1();
            this.btns();
            this.RightEv()
            return;
          }
          e.preventDefault();
          this.spaceDialogEvt();
        }

        // 键盘1事件（标签操作后）
        if (e.keyCode == 49 || e.keyCode == 97) {
          this.fingerboard1Evt();
        }
        //键盘2事件（标签操作后）
        if (e.keyCode == 50 || e.keyCode == 98) {
          this.fingerboard2Evt();
        }
        //键盘Delete事件
        if (e.keyCode == 8 || e.keyCode == 46) {
          if (
            this.dialogVisible == true ||
            this.searchLabelDialog == true ||
            this.rightLabelDialog == true ||
            this.deleteVisible == true ||
            this.uploadVisible == true
          ) {
            e.preventDefault();
            return;
          }
          this.deleteVisible = true;
        }
      }
      //键盘I事件
      if (e.keyCode == 73) {
        if (this.changing >= 3) {
          this.changing = 1;
        } else {
          this.changing++;
        }
        this.changingEvt(this.changing);
      }
      //shift 事件
      if (e.keyCode == 16) {
        this.shift = true;
        this.shiftFirst = true;
      }
      //键盘0清除选择
      if (e.keyCode == 48 || e.keyCode == 96 || e.keyCode == 67) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          return;
        }
        this.imgArr = this.imgArr.map(res => {
          res.select = false;
          return res;
        });
        this.selectArr = this.imgArr.filter(res => res.select == true);
      }
      //键盘A事件（全选）
      if (e.keyCode == 65) {
        this.imgArr = this.imgArr.map(res => {
          res.select = true;
          return res;
        });
        this.selectArr = this.imgArr.filter(res => res.select == true);
        this.selectAllText = "取消全选";
        this.selectAllBgColor = "#909399";
      }
      //键盘v事件
      if (e.keyCode == 86) {
        if (this.dialogVisible == true) {
          this.changingImg = !this.changingImg;
          // this.$nextTick(() => {
          //     new flexImages({
          //         selector: ".spaceDialogImg1",
          //     });
          // });
        }
      }
      //Page Up 翻页
      if (e.keyCode == 34) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          e.preventDefault();
          return;
        }
        this.loading = true; // 设置loading为true
        e.preventDefault();
        this.LeftEv()
        delay(() => {
          this.currentPage1++;
          getVdtCodeApi({
            is_tag: this.checkInputIs_tag,
            not_tag: this.checkInputNot_tag,
            author: this.authorInput,
            time: this.value2,
            sort: this.sort,
            tag_type: this.radio[0],
            tag_id: this.labelId,
            source_id: this.frontOrderInput,
            behindOrder: this.behindOrderInput,
            limit: this.paginationInput,
            page: this.currentPage1,
            process: this.process,
            type: this.adminuser,
            dup: this.Check,
            c: this.c,
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.loading = false; // 请求完成后设置loading为false
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total
              };
              this.pagefenye = true; //点击分页 滚动条为0
              let as = document.querySelector(
                ".el-table__body-wrapper , .flex-images"
              );
              as.scrollTop = 0;
              this.imgScrollEvt(as);
            }
          });
        }, 300);
      }
      // Page Down向后分页
      if (e.keyCode == 33) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          e.preventDefault();
          this.RightEv()
          return;
        }
        this.loading = true; // 设置loading为true
        delay(() => {
          if (this.currentPage1 <= 1) {
            this.currentPage1 = 1;
          } else {
            this.currentPage1--;
          }
          getVdtCodeApi({
            is_tag: this.checkInputIs_tag,
            not_tag: this.checkInputNot_tag,
            author: this.authorInput,
            time: this.value2,
            sort: this.sort,
            tag_type: this.radio[0],
            tag_id: this.labelId,
            source_id: this.frontOrderInput,
            behindOrder: this.behindOrderInput,
            limit: this.paginationInput,
            page: this.currentPage1,
            process: this.process,
            type: this.adminuser,
            dup: this.Check,
            c: this.c,
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.loading = false; // 请求完成后设置loading为false
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total
              };
              this.pagefenye = true; //点击分页 滚动条为0
              let as = document.querySelector(
                ".el-table__body-wrapper  , .flex-images "
              );
              as.scrollTop = 0;
              this.imgScrollEvt(as);

            }
          });
        }, 300);
      }
      //键盘5事件  剩余全否
      if (e.keyCode == 53 || e.keyCode == 101) {
        this.allNoEvt();
      }
    },

    //滑动事件
    imgScrollEvt(e) { },
    //弹窗属于事件
    belongEvt() {
      this.fingerboard1Evt();
    },
    //弹窗不s属于事件
    noBelongEvt() {
      this.fingerboard2Evt();
    },

    //键盘1事件
    fingerboard1Evt() {
      const formData = new FormData();
      if (this.dialogVisible == true && this.operateNum.show == true) {
        this.belongShow = 0;

        this.spaceObjData[this.spaceDialogId[0]].label = this.spaceObjData[
          this.spaceDialogId[0]
        ].label.map(res => {
          for (let key in res.children) {
            if (res.children[key].id == this.labelId) {
              res.children[key].status = 0;
            }
          }
          return res;
        });

        return;
      }
      if (this.operateNum.show == true) {
        this.getSourceId().map(res => {
          formData.append("source_ids[]", res);
        });
        formData.append("is_tag", this.labelId);
        formData.append("c", this.c);
        fingerboardNumApi(formData).then(res => {
          if (res.code == 1000) {
            // this.loading = true
            var id = this.imgArr.map(res => {
              return res.source_id;
            });
            singleLabelApi({
              tag_id: this.labelId,
              process: this.process,
              source_ids: id,
              c: this.c,
            }).then(val => {
              if (val.code == 1000) {
                this.operateNum = val.data;
                this.operateNum.show = true;
                let arr = [];
                this.imgArr.map(v => {
                  val.data.refers.map(l => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
                // this.loading = false
              }
            });
            this.belongShow = true;
          }
        });
      }
    },
    //键盘2事件
    fingerboard2Evt() {
      if (this.labelAjax == true) {
        return;
      }
      const formData = new FormData();
      if (this.operateNum.show == true && this.dialogVisible == true) {
        this.belongShow = 1;
        this.spaceObjData[this.spaceDialogId[0]].label = this.spaceObjData[
          this.spaceDialogId[0]
        ].label.map(res => {
          for (let key in res.children) {
            if (res.children[key].id == this.labelId) {
              res.children[key].status = 1;
            }
          }
          return res;
        });
        return;
      }
      if (this.operateNum.show == true) {
        this.getSourceId().map(res => {
          formData.append("source_ids[]", res);
        });
        formData.append("not_tag", this.labelId);
        formData.append("c", this.c);

        fingerboardNumApi(formData).then(res => {
          if (res.code == 1000) {
            // this.loading = true
            var id = this.imgArr.map(res => {
              return res.source_id;
            });
            singleLabelApi({
              tag_id: this.labelId,
              process: this.process,
              source_ids: id,
              c: this.c,
            }).then(val => {
              if (val.code == 1000) {
                this.operateNum = val.data;
                this.operateNum.show = true;
                let arr = [];
                this.imgArr.map(v => {
                  val.data.refers.map(l => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
                // this.loading = false
              }
            });
            this.belongShow = false;
          }
        });
      }
    },
    //图片点击事件
    imgEvt(e, index) {
      if (this.selectArr.length >= 1 && this.shift === true) {
        let start,
          end = "";
        for (var i = 0; this.imgArr.length > i; i++) {
          if (this.imgArr[i].source_id === e.source_id) {
            start = i;
          }
          if (
            this.imgArr[i].source_id !== e.source_id &&
            this.imgArr[i].select === true
          ) {
            end = i;
          }
        }
        if (start || (start == 0 && end)) {
          if (start > end) {
            let temp = "";
            temp = end;
            end = start;
            start = temp;
          } else {
            start++;
          }
          for (var i = 0; this.imgArr.length > i; i++) {
            if (i >= start && i < end) {
              this.imgArr[i].select = true;
            }
          }
        }
      }
      this.imgArr = this.imgArr.map(res => {
        if (res.source_id == e.source_id) {
          if (res.select) {
            res.select = "";
          } else {
            res.select = true;
          }
        }
        return res;
      });
      this.selectArr = this.imgArr.filter(res => res.select == true);
      this.activeIndex_copy = index
    },
    //排序
    sortEvt(res) {
      this.sort = res;
      switch (res) {
        case "8":
          this.sortName = "点击查看次数最多";
          this.review = 8;
          break;
        case "9":
          this.sortName = "收藏最多";
          this.favorite = 9;
          break;
        case "1":
          this.sortName = "上传时间-升序";
          this.review = null;
          this.favorite = null;
          break;
        case "2":
          this.sortName = "上传时间-降序";
          this.review = null;
          this.favorite = null;
          break;
        case "3":
          this.sortName = "文件大小-升序";
          this.review = null;
          this.favorite = null;
          break;
        case "4":
          this.sortName = "文件大小-降序";
          this.review = null;
          this.favorite = null;
          break;
        case "5":
          this.sortName = "文件尺寸-升序";
          this.review = null;
          this.favorite = null;
          break;
        case "6":
          this.sortName = "文件尺寸-降序";
          this.review = null;
          this.favorite = null;
          break;
        case "7":
          this.sortName = "下载次数最多";
          this.review = null;
          this.favorite = null;
          break;
        case "10":
          this.sortName = "相似数量最多";
          this.review = null;
          this.favorite = null;
          break;
      }
      getVdtCodeApi({
        sort: res,
        tag_type: this.radio[0],
        tag_id: this.labelId,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        source_id: this.frontOrderInput,
        behindOrder: this.behindOrderInput,
        limit: this.paginationInput,
        process: this.process,
        orField: this.orField,
        orWhere: this.orWhere,
        type: this.adminuser,
        dup: this.Check,
        c: this.c,
      }).then(res => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
          this.listNum = {
            download_num: res.data.download_num,
            review: res.data.review,
            favorite: res.data.favorite,
            total: res.data.total
          };
          this.operateNum.all = res.data.total;
        }
      });
      this.setSessStorage();
    },
    //分页
    handleCurrentChange(e) {
      this.loading = true; // 设置loading为true
      getVdtCodeApi({
        sort: this.sort,
        behindOrder: this.behindOrderInput,
        limit: e,

        time: this.value2,
        c: this.c,
        orField: this.orField,
        orWhere: this.orWhere,
        process: this.process,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,

        author: this.authorInput,

        time: this.value2,
        tag_type: this.radio[0],
        tag_id: this.labelId,
        source_id: this.frontOrderInput,
        type: this.adminuser,
        dup: this.Check,

        compressSize: this.parseSizeRange(this.compressSize),
        sizeRange_1: this.sizeRange_1,
        xiazai_shu: this.parseSizeRange(this.xiazai_shu),
        chaKan_shu: this.parseSizeRange(this.chaKan_shu),
        author_id: this.selectedNode && this.selectedNode.id ? this.selectedNode.id : '',

        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,
        design: this.design,
        baoMi: this.baoMi,
        pinFen: this.pinFen,
        shouCang: this.parseSizeRange(this.shouCang),
      }).then(res => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
          this.operateNum.all = res.data.total;

          this.loading = false; // 设置loading为false
          this.pagefenye = true;
          let as = document.querySelector(
            ".flex-images , .el-table__body-wrapper "
          );
          as.scrollTop = 0;

          this.imgScrollEvt(as);
          this.listNum = {
            download_num: res.data.download_num,
            review: res.data.review,
            favorite: res.data.favorite,
            total: res.data.total
          };
        }
      });
    },
    //分页输入框
    limitEvt(e) {
      getVdtCodeApi({
        sort: this.sort,
        behindOrder: this.behindOrderInput,
        limit: e,

        time: this.value2,
        c: this.c,
        orField: this.orField,
        orWhere: this.orWhere,
        process: this.process,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,

        author: this.authorInput,

        time: this.value2,
        tag_type: this.radio[0],
        tag_id: this.labelId,
        source_id: this.frontOrderInput,
        type: this.adminuser,
        dup: this.Check,

        compressSize: this.parseSizeRange(this.compressSize),
        sizeRange_1: this.sizeRange_1,
        xiazai_shu: this.parseSizeRange(this.xiazai_shu),
        chaKan_shu: this.parseSizeRange(this.chaKan_shu),
        author_id: this.selectedNode && this.selectedNode.id ? this.selectedNode.id : '',

        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,
        design: this.design,
        baoMi: this.baoMi,
        pinFen: this.pinFen,
        shouCang: this.parseSizeRange(this.shouCang),




      }).then(res => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.listNum = {
            download_num: res.data.download_num,
            review: res.data.review,
            favorite: res.data.favorite,
            total: res.data.total
          };
          this.changing = res.data.show;
          this.sort = res.data.sort;
        }
      });
    },
    //标签查询获取焦点
    searchLabelEvt() {
      this.searchLabelDialog = true;
    },
    searchLabel1Evt() {
      this.searchFor = true;
    },
    //
    mousemoveEvt(res) {
      this.mousemoveId = res.source_id;
    },
    mouseoutEvt() {
      this.mousemoveId = "";
    },
    //空格弹窗打开
    spaceDialogEvt() {
      if (this.checkValue) {
        return;
      }
      if (this.spaceDialogNum < 0) {
        this.spaceDialogNum = 0;
      }
      let arrID = this.selectArr.map(res => {
        return res.source_id;
      });
      let determine = false;
      this.spaceDialogId = [];
      this.spaceDialogId.push(arrID[this.spaceDialogNum]);

      this.spaceSrc = this.selectArr[this.spaceDialogNum].big_img;
      this.spaceDialogNum++;
      if (JSON.stringify(this.spaceObjData) !== "{}") {
        for (let key in this.spaceObjData) {
          if (key == this.spaceDialogId[0]) {
            this.spaceImgInfo = this.spaceObjData[key].info;
            this.spaceWidth = this.spaceObjData[key].w;
            this.spaceHeight = this.spaceObjData[key].h;
            this.spaceLabelArr = this.spaceObjData[key].label;
            this.spaceLabelArr.map(a => {
              for (const key in a.children) {
                if (a.children[key].title == this.operateLabelInput) {
                  if (a.children[key].status == 0) {
                    this.belongShow = 0;
                  } else if (a.children[key].status == 1) {
                    this.belongShow = 1;
                  } else if (a.children[key].status == 3) {
                    this.belongShow = 3;
                  }
                }
              }
            });
            // if (this.spaceObjData[this.spaceDialogId[0]].front) {
            //   this.frontSpaceWidth = "auto";
            //   this.frontSpaceHeight = "100%";
            // } else {
            //   this.frontSpaceWidth = "100%";
            //   this.frontSpaceHeight = "auto";
            // }
            determine = true;
          }
        }
      }
      if (determine == true) {
        determine = false;
        return;
      }
      const formData = new FormData();
      formData.append("source_ids[]", this.spaceDialogId);
      formData.append("process", this.process);
      formData.append("c", this.c);
      getImgLabelApi(formData).then(res => {
        if (res.code == 1000) {
          let imginfo = {
            id: this.spaceDialogId[0],
            author: res.data.author,
            create_time: res.data.create_time,
            w: res.data.width,
            h: res.data.height
          };
          this.spaceLabelArr = res.data.tag;
          this.spaceImgInfo = imginfo;

          this.spaceLabelArr = this.spaceLabelArr.map(a => {
            for (const key in a.children) {
              if (a.children[key].title == this.operateLabelInput) {
                if (a.children[key].status == 0) {
                  this.belongShow = 0;
                } else if (a.children[key].status == 1) {
                  this.belongShow = 1;
                } else if (a.children[key].status == 3) {
                  this.belongShow = 3;
                }
              }
            }
            return a;
          });
          this.spaceObjData[this.spaceDialogId[0]] = {};
          this.spaceObjData[this.spaceDialogId[0]].label = this.spaceLabelArr;
          this.spaceObjData[this.spaceDialogId[0]].info = {
            ...imginfo
          };
          let num = this.spaceImgInfo.w / this.spaceImgInfo.h;
          if (res.data.height - 0 > res.data.width - 0) {
            this.spaceObjData[this.spaceDialogId[0]].front = true;
            this.frontSpaceWidth = "auto";
            // this.frontSpaceHeight = "850px";
            this.frontSpaceHeight = "100%";
          } else {
            this.spaceObjData[this.spaceDialogId[0]].front = false;
            this.frontSpaceWidth = "100%";
            // this.frontSpaceWidth = "550px";
            this.frontSpaceHeight = "auto";
          }
          if (parseInt(num) == 3) {
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            this.spaceWidth = "auto";
            this.spaceHeight = "500px";
            this.spaceObjData[this.spaceDialogId[0]].h = "500px";
          } else if (parseInt(num) == 4) {
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            this.spaceWidth = "auto";
            this.spaceHeight = "400px";
            this.spaceObjData[this.spaceDialogId[0]].h = "400px";
          } else if (parseInt(num) == 5) {
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            this.spaceWidth = "auto";
            this.spaceHeight = "317px";
            this.spaceObjData[this.spaceDialogId[0]].h = "300px";
          } else {
            this.spaceWidth = "auto";
            this.spaceHeight = "100%";
            // this.spaceHeight = "850px";
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            // this.spaceObjData[this.spaceDialogId[0]].h = "850px";
            this.spaceObjData[this.spaceDialogId[0]].h = "100%";
          }
        }
      });
    },

    //去重页面  123123
    spaceDialogEvt1() {
      if (this.spaceDialogNum < 0) {
        this.spaceDialogNum = 0;
      }
      let arrID = this.selectArr.map(res => {
        return res.source_id;
      });
      let determine = false;
      this.spaceDialogId = [];
      this.spaceDialogId.push(arrID[this.spaceDialogNum]);
      const formData = new FormData();
      formData.append("source_id", this.spaceDialogId);
      formData.append("c", this.c);
      CheckedApi(formData).then(res => {
        if (res.code == 1000) {
          let imginfo = {
            id: this.spaceDialogId[0],
            author: res.data.refer.author,
            create_time: res.data.refer.create_time,
            cover_pixel: res.data.refer.cover_pixel
          };
          this.Deduplication = res.data.duplicate;
          this.reviews = res.data.refer.review;
          this.currentPage = 1;
          this.spaceImgInfo = imginfo;
          determine = false;
        }
      });
      this.spaceSrc = this.selectArr[this.spaceDialogNum].big_img;

      this.spaceDialogNum++;

      if (determine == true) {
        determine = false;
      }
    },
    //空格弹窗全部否
    allNoEvt() {
      this.spaceLabelArr = this.spaceLabelArr.map(res => {
        for (const key in res.children) {
          if (res.children[key].status == 3) {
            res.children[key].status = 1;
          }
        }
        return res;
      });
    },
    //图片切换
    arrowLeftEvt() {
      if (this.spaceDialogNum == 1) {
        return;
      }
      this.spaceDialogNum -= 2;
      this.spaceDialogEvt();
    },
    //去重页面的左点击 为上一页
    arrowLeftEvt1() {
      if (this.spaceDialogNum == 1) {
        return;
      }
      this.spaceDialogNum -= 2;
      this.spaceDialogEvt1();
      this.btns();
      this.LeftEv()
    },
    //图片切换
    arrowRightEvt() {
      if (this.spaceDialogNum == this.selectArr.length) {
        return;
      }
      this.spaceDialogEvt();
    },
    //去重页面的右点击 为下一页
    arrowRightEvt1() {
      if (this.spaceDialogNum == this.selectArr.length) {
        return;
      }
      this.spaceDialogEvt1();
      this.btns();
      this.RightEv()
    },
    LeftEv() {
      let imgElement = document.querySelector('.imgnst');
      // 创建一个新的参数数组，用于存储匹配的对象
      this.selectArr.forEach(res => {
        this.imagesToDelete_box.forEach((val => {
          if (res.source_id == val.source_id) {
            var newParameters = {
              source_id: res.source_id
            };
            this.newParameters.push(newParameters);
            this.newParameters.map(res => res.source_id)
            // 提取this.newParameters中的source_id并存储在sourceIds变量中
            const sourceIds = this.newParameters.map(res => res.source_id);
            if (sourceIds.includes(this.spaceDialogId[0])) {
              this.clicke = false;
              imgElement.src = 'https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/x2.png';
            } else {
              imgElement.src = 'https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/x.png';
              this.clicke = false;
            }
          };
        }))
      });
    },
    RightEv() {
      let imgElement = document.querySelector('.imgnst');
      this.selectArr.forEach(res => {
        this.imagesToDelete_box.forEach((val => {
          if (res.source_id == val.source_id) {
            var newParameters = {
              source_id: res.source_id
            };
            this.newParameters.push(newParameters);
            this.newParameters.map(res => res.source_id)
            // 提取this.newParameters中的source_id并存储在sourceIds变量中
            const sourceIds = this.newParameters.map(res => res.source_id);
            if (sourceIds.includes(this.spaceDialogId[0])) {
              this.clicke = true;
              imgElement.src = 'https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/x.png';
            } else {
              imgElement.src = 'https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/x.png';
              this.clicke = false;
            }
          };
        }))
      });
    },
    btns() {
      const btns = document.getElementsByClassName("btn");
      for (let i = 0; i < btns.length; i++) {
        const btn = btns[i];
        const source_id = btn.id.replace(/[vx]$/, ""); // 提取source_id

        // 根据按钮的 source_id 和默认的图片链接重置图片 src
        btn.src =
          source_id + "v" === btn.id
            ? this.handleButtonSrc
            : this.correctButtonSrc;
      }
    },
    //下一页 重置按钮样式
    qiehuan() {
      const imageElement = document.querySelector('.SelectedEV');
      if (imageElement) {
        imageElement.src = "https://v2-3ddang-static-files.oss-cn-chengdu.aliyuncs.com/tmp/x.png"; // 替换成新的图片 URL
      }
    },
    //空格弹窗切换
    changingImgEvt() {
      this.changingImg = !this.changingImg;
    },
    // 获取已选中图片的source_id
    getSourceId() {
      var source_ids = this.selectArr.map(res => res.source_id);
      return source_ids;
    },
    //搜索弹窗打开
    searchDialogEvt() {
      if (this.labelArr.length !== 0) {
        return;
      }
      this.labelArr = [];
      getLabelApi({
        process: this.process,
        type: 2,
        c: this.c,
      }).then(res => (this.labelArr = res.data.tag));
    },

    //右键搜索弹窗打开
    rightDialogEvt() {
      const formData = new FormData();
      this.getSourceId().map(res => {
        formData.append("source_ids[]", res);
      });
      formData.append("c", this.c);
      getImgLabelApi(formData).then(res => {
        if (res.code == 1000) {
          this.labelArr = res.data.tag;
        }
      });
    },
    //标签改变状态
    colorEvt(e) {
      this.labelArr = this.labelArr.map(val => {
        if (val.one == true && e.parent_id == val.id) {
          for (let key in val.children) {
            if (e.id == val.children[key].id) {
              if (val.children[key].status == 1) {
                val.children[key].status = 3;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 3) {
                val.children[key].status = 0;
              } else if (val.children[key].status == 2) {
                val.children[key].status = 1;
              }
            }
          }
        } else {
          for (let key in val.children) {
            if (e.id == val.children[key].id) {
              if (val.children[key].status == 1) {
                val.children[key].status = 3;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 3) {
                val.children[key].status = 0;
              } else if (val.children[key].status == 2) {
                val.children[key].status = 1;
              }
            }
          }
        }

        return val;
      });
    },
    color1Evt(e) {
      this.spaceLabelArr = this.spaceLabelArr.map(val => {
        if (val.one == true && e.parent_id == val.id) {
          for (let key in val.children) {
            if (e.id == val.children[key].id) {
              if (val.children[key].status == 1) {
                val.children[key].status = 3;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 3) {
                val.children[key].status = 0;
              }
            }
          }
        }
        return val;
      });
    },
    //标签事件（搜索弹窗）
    searchLabEvt(e) {
      this.labelArr = this.labelArr.map(val => {
        if (val.one == true && e.parent_id == val.id) {
          for (let key in val.children) {
            val.children[key].status = 1;
            if (e.id == val.children[key].id) {
              val.children[key].status = 0;
            }
          }
          return val;
        }
        for (let key in val.children) {
          if (e.id == val.children[key].id) {
            if (val.children[key] !== null) {
              if (
                val.children[key].status == 3 ||
                val.children[key].status == 2
              ) {
                val.children[key].status = 0;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 1) {
                val.children[key].status = 3;
              }
            }
          }
        }
        return val;
      });
    },
    //点击标签（标签操作）
    labelSearchEvt(e) {
      this.labelArr = this.labelArr.map(val => {
        if (val.one == true && e.parent_id == val.id) {
          this.labelAjax = true;
        } else {
          this.labelAjax = false;
        }
        for (let key in val.children) {
          val.children[key].status = 3;
          if (e.id == val.children[key].id) {
            val.children[key].status = 1;
            getVdtCodeApi({
              is_tag: this.checkInputIs_tag,
              not_tag: this.checkInputNot_tag,
              author: this.authorInput,
              time: this.value2,
              source_id: this.frontOrderInput,
              tag_id: val.children[key].id,
              process: this.process,
              type: this.adminuser,
              dup: this.Check,
              c: this.c,
            }).then(res => {
              if (res.code == 1000) {
                this.operateNum.show = true;
                this.operateNum.all = res.data.total;
                this.operateNum.belong = res.data.belong;
                this.operateNum.not_belong = res.data.not_belong;
                this.operateNum.not_review = res.data.not_review;
                this.imgArr = res.data.data;
                this.listNum = {
                  download_num: res.data.download_num,
                  review: res.data.review,
                  favorite: res.data.favorite,
                  total: res.data.total
                };
                let arr = [];
                this.imgArr.map(v => {
                  res.data.data.map(l => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
              }
            });
            setTimeout(() => {
              this.searchLabelDialog = false;
              this.operateLabelInput = e.title;
              this.labelId = e.id;
              this.radio = ["1"];
              this.setSessStorage();
            }, 500);
          }
        }
        return val;
      });
    },
    //确认关闭右键弹窗
    submitRightLabelEvt() {
      //绿色标签
      let is_tag = [];
      //红色标签
      let not_tag = [];
      let other_tag = [];
      let hui_tag = [];
      this.labelArr.map(res => {
        for (let key in res.children) {
          if (res.children[key].status == 0) {
            is_tag.push(res.children[key].id);
          }
          if (res.children[key].status == 1) {
            not_tag.push(res.children[key].id);
          }
          if (res.children[key].status == 2) {
            other_tag.push(res.children[key].id);
          }
          if (res.children[key].status == 3) {
            hui_tag.push(res.children[key].id);
          }
        }
      });
      stickLabelApi({
        source_ids: this.getSourceId(),
        is_tag,
        not_tag,
        other_tag,
        c: this.c
      }).then(res => {
        if (res.code == 1000) {
          if (this.operateNum.show) {
            let id = this.getSourceId();
            let arr = is_tag.filter(res => res == this.labelId);
            let arr1 = not_tag.filter(res => res == this.labelId);
            let arr2 = hui_tag.filter(res => res == this.labelId);
            if (arr.length !== 0) {
              this.imgArr = this.imgArr.map(res => {
                id.map(val => {
                  if (res.source_id == val) {
                    res.status = 0;
                  }
                });
                return res;
              });
            }
            if (arr1.length !== 0) {
              this.imgArr = this.imgArr.map(res => {
                id.map(val => {
                  if (res.source_id == val) {
                    res.status = 1;
                  }
                });
                return res;
              });
            }
            if (arr2.length !== 0) {
              this.imgArr = this.imgArr.map(res => {
                id.map(val => {
                  if (res.source_id == val) {
                    res.status = 3;
                  }
                });
                return res;
              });
            }
          }
          this.rightLabelDialog = false;
        }
      });
    },

    //确认删除图片
    hadnEvt() {
      // 创建一个包含需要传递给后端的数据的对象
      const dataToSend = {
        imagesToDelete: this.imagesToDelete_box,
        // 可以在这里添加其他需要传递的数据字段
        c: this.c
      };
      // 如果dataToSend包含数据，执行相应操作
      // 例如调用cloneEvtApi并处理响应
      cloneEvtApi(dataToSend).then(res => {
        // 清空imagesToDelete_box_two数组
        if (res.code == 1000) {
          this.imagesToDelete_box = [];
          this.spaceDialogNum = 0;
          this.liEvt();
          this.dialogVisible = false;
        }
      });
    },
    restoreButtonStyles(source_id) {
      // 在这个函数中，你可以将按钮样式还原为原始状态
      // 例如，通过重新设置按钮的类名、样式属性等来实现还原
      // 你需要根据你的应用程序代码来编写此部分代码
      const vButton = document.getElementById(source_id.dup_source_id + "v");
      const xButton = document.getElementById(source_id.dup_source_id + "x");

      if (vButton && xButton) {
        vButton.src = this.handleButtonSrc;
        xButton.src = this.correctButtonSrc;
      }
    },
    //确认关闭空格弹窗
    submitSpaceLabelEvt() {
      let data = {};
      for (let key in this.spaceObjData) {
        data[key] = {};
        data[key].is_tag = [];
        data[key].not_tag = [];
        data[key].hui_tag = [];
        this.spaceObjData[key].label.map(res => {
          for (let v in res.children) {
            if (res.children[v].status == 0) {
              data[key].is_tag.push(res.children[v].id);
            }
            if (res.children[v].status == 1) {
              data[key].not_tag.push(res.children[v].id);
            }
            if (res.children[v].status == 3) {
              data[key].hui_tag.push(res.children[v].id);
            }
          }
        });
      }
      spaceDataSubmitApi({
        data,
        c: this.c
      }).then(res => {
        if (res.code == 1000) {
          if (this.operateNum.show) {
            this.imgArr = this.imgArr.map(i => {
              for (let v in data) {
                if (i.source_id == v) {
                  let arr = data[v].is_tag.filter(res => res == this.labelId);
                  let arr1 = data[v].not_tag.filter(res => res == this.labelId);
                  let arr2 = data[v].hui_tag.filter(res => res == this.labelId);
                  if (arr.length !== 0) {
                    i.status = 0;
                  }
                  if (arr1.length !== 0) {
                    i.status = 1;
                  }
                  if (arr2.length !== 0) {
                    i.status = 3;
                  }
                }
              }
              return i;
            });
          }
          this.spaceObjData = {};
          this.$message({
            message: "更改成功",
            type: "success"
          });
          this.dialogVisible = false;
        }
      });
    },

    //空格空格弹窗关闭
    handleClose(done) {
      this.dialogVisible = false;
      this.deleteVisible = false;
      this.spaceDialogNum = 0;
    },
    //关闭弹窗
    closeEvt() {
      this.labelArr = [];
    },
    //关闭空格弹窗

    spaceCloseDiaEvt() {
      this.spaceObjData = {};
      this.spaceDialogNum = 0;
    },
    //去重弹窗关闭事件
    spaceCloseDiaEvt1() {
      // 关闭弹窗时清除大图元素和相关状态
      if (this.currentLargeImage) {
        // 移除所有带有 "button_box" 类名的元素
        const buttonsMax = document.getElementsByClassName("button_box");

        for (let i = 0; i < buttonsMax.length; i++) {
          buttonsMax[i].style.display = "none";
        }
        this.resetClickedButtons();
        this.currentLargeImage.remove(); // 移除大图元素
        this.currentLargeImage = null; // 清空当前大图信息
        this.imagesToDelete = [];
      }
      // 恢复小图和按钮显示
      this.restoreSmallImages();

      this.imagesToDelete = [];
      this.imagesToDelete_box = []
      // 恢复按钮样式为默认状态
      this.btns();
      this.clicke = false
    },

    // 重置之前点击的按钮样式
    resetClickedButtons() {
      // 重置之前点击的按钮为初始状态
      for (const clickedButton of this.clickedButtons) {
        const buttonType = clickedButton.buttonType;
        const image = clickedButton.image;
        // 根据按钮类型和图像信息重置按钮样式
        // 重置按钮样式为初始状态
        const buttonId = image.source_id + (buttonType === 1 ? "v" : "x");
        const buttonElement = document.getElementById(buttonId);
        if (buttonElement) {
          buttonElement.style.backgroundColor = "initial";
          buttonElement.style.color = "initial";
          // 重置其他样式属性
        }
      }
      // 清空已记录的点击按钮信息
      this.clickedButtons = [];
    },
    //切换标签
    labelEvt(res) {
      this.spaceLabelArr = this.spaceLabelArr.map(val => {
        if (val.one == true && res.parent_id == val.id) {
          for (let key in val.children) {
            val.children[key].status = 1;
            if (res.id == val.children[key].id) {
              val.children[key].status = 0;
            }
          }
          return val;
        }
        for (let key in val.children) {
          if (res.id == val.children[key].id) {
            if (val.children[key] !== null) {
              if (
                val.children[key].status == 3 ||
                val.children[key].status == 2
              ) {
                val.children[key].status = 0;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 1) {
                val.children[key].status = 3;
              }
            }
          }
        }
        return val;
      });
      for (let key in this.spaceObjData) {
        if (key == this.spaceDialogId[0]) {
          this.spaceObjData[key].label = this.spaceLabelArr;
        }
      }
    },
    //切换排序方式
    changingEvt(num) {
      // show
      showApi({
        show: num,
      }).then(res => {
        if (res.code == 1000) {
          this.changing = num;
        }
      });
    },
    //标签操作事件（头部）
    checkboxEvt(e) {
      this.loading = true;
      if (e.length == 0) {
        delay(() => {
          this.radio = this.radioNum;
          this.setSessStorage();
          this.selectImg();
        }, 300);
        return;
      }
      this.radio = [];
      if (e.length == 1) {
        this.radio.push(e[0]);
      } else {
        this.radio.push(e[1]);
      }
      delay(() => {
        this.radioNum = this.radio;
        this.setSessStorage();
        this.selectImg();
      }, 300);
    },
    //改变图片选项
    checkbox1Evt(e) {
      e.selectArr = e.selectArr.slice(-1);
    },
    //图片鼠标右键事件
    rightClickEvt() {
      if (this.selectArr.length != 0) {
        this.labelArr = [];
        this.rightLabelDialog = true;
      }
    },
    //出现改变弹窗
    leftSelectEvt(e) {
      this.showChangeImg(e, true);
    },
    //关改变弹窗闭
    cancelEvt(e) {
      this.showChangeImg(e, false);
    },
    //弹窗组件方法
    cancel(params) {
      this.searchFor = params;
    },
    revise(params) {
      this.imgArr = params.data;
      this.total = params.total;
      this.paginationInput = params.limit;
      this.operateNum.all = params.total;
    },
    reviseText(params) {
      let str = "";
      this.checkInputIs_tag = params.filter(res => res.status == 0);
      this.checkInputNot_tag = params.filter(res => res.status == 1);
      this.checkInputIs_tag = this.checkInputIs_tag.map(res => {
        return res.id;
      });
      this.checkInputNot_tag = this.checkInputNot_tag.map(res => {
        return res.id;
      });
      params.map(res => {
        str += `${res.title},`;
      });
      this.checkInput = str;
      this.setSessStorage();
    },
    //改变弹出方法
    showChangeImg(e, boolean) {
      this.imgArr = this.imgArr.map(res => {
        if (res.source_id == e.source_id) {
          res.leftSelect = boolean;
        }
        return res;
      });
      this.$store.dispatch("setCoverShow", boolean);
    },
    //上传
    uploadEvt() {
      this.uploadVisible = true;
      // window.open('/upload')
      // this.$router.push('/upload')
    },
    //确认改变图片
    changeImgEvt(e) {
      var str = this.operationArr[0].selectArr[0].slice(-1);
      var arr = this.selectArr.map(val => {
        return val.source_id;
      });
      changeImgApi({
        process: str,
        source_ids: arr,
        c: this.c,
      }).then(res => {
        if (res.code == 1000) {
          this.imgArr = this.imgArr.map(a => {
            this.selectArr.map(val => {
              if (a.source_id == val.source_id) {
                a = {};
              }
            });
            return a;
          });
          var arr = JSON.parse(
            JSON.stringify(this.$store.getters.menuList)
          ).splice(0, 1);
          this.operationArr = arr.map(res => {
            res.selectArr = [`${res.id}_${this.process}`];
            return res;
          });
          this.showChangeImg(e, false);
        }
      });
    },
    //选择作者（搜索）
    authorEvt() {
      this.setSessStorage();
      this.selectImg();
      this.focusDiyIpt = false;
    },
    //选择时间（搜索）
    timeEvt(e) {
      this.setSessStorage();
      this.selectImg();
    },
    clearEvt1() {
      this.checkInputIs_tag = [];
      this.checkInputNot_tag = [];
      this.selectImg();
    },
    clearEvt2() {
      this.selectImg();
      this.cleanUpEvt();
    },
    clearEvt3() {
      this.selectImg();
      this.cleanUpEvt();
    },
    clearEvt4() {
      this.selectImg();
      this.cleanUpEvt();
    },
    //查询
    selectImg() {
      getVdtCodeApi({

        time: this.value2,
        c: this.c,
        orField: this.orField,
        orWhere: this.orWhere,
        process: this.process,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,

        author: this.authorInput,

        time: this.value2,
        tag_type: this.radio[0],
        tag_id: this.labelId,
        source_id: this.frontOrderInput,
        type: this.adminuser,
        dup: this.Check,

        compressSize: this.parseSizeRange(this.compressSize),
        sizeRange_1: this.sizeRange_1,
        xiazai_shu: this.parseSizeRange(this.xiazai_shu),
        chaKan_shu: this.parseSizeRange(this.chaKan_shu),
        author_id: this.selectedNode && this.selectedNode.id ? this.selectedNode.id : '',

        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,
        design: this.design,
        baoMi: this.baoMi,
        pinFen: this.pinFen,
        shouCang: this.parseSizeRange(this.shouCang),


      }).then(res => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
          this.listNum = {
            download_num: res.data.download_num,
            review: res.data.review,
            favorite: res.data.favorite,
            total: res.data.total
          };
          this.loading = false;
          this.operateNum.all = res.data.total;
          if (this.operateNum.show == true) {
            this.operateNum.belong = res.data.belong;
            this.operateNum.not_belong = res.data.not_belong;
            this.operateNum.not_review = res.data.not_review;
          }
        }
      });
    },
    //存储操作数据
    setSessStorage() {
      var grounding = {};
      grounding.select = {
        process: this.process,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        checkInput: this.checkInput,
        source_id: this.frontOrderInput,
        operateLabelInput: this.operateLabelInput,
        radio: this.radio,
        labelId: this.labelId,
        sort: this.sort,
        type: this.adminuser
      };
      sessionStorage.setItem("grounding", JSON.stringify(grounding));
    },
    //id查询
    frontOrderEvt() {
      this.setSessStorage();
      this.selectImg();
      this.focusDiyIpt = false;
    },
    focusDiyIptEvt() {
      this.focusDiyIpt = true;
    },
    //清除搜索条件
    cleanUpEvt() {
      console.log(1231231231);
      this.checkInput = "";
      this.behindOrderInput = "";
      this.frontOrderInput = "";
      this.value2 = "";
      this.authorInput = "";
      this.labelId = "";
      this.labelArr = [];
      this.checkInputIs_tag = [];
      this.checkInputNot_tag = [];
      this.operateLabelInput = "";
      this.operateNum.show = false;
      this.selectArr = [];
      this.sortName = "排序方式";
      this.sort = null;
      this.adminuser = '',

      this.baoMi = '';
      this.pinFen = '';
      this.xiazai_shu = "";
      this.chaKan_shu = "";
      this.shouCang = "";
      this.design = "";
      this.value4 = "";
      this.value3 = "";
      this.value1 = "";

      this.compressSize = '';

      for (let i = 1; i <= 2; i++) {
        const refName = `sizePopover${i}`;
        const popover = this.$refs[refName];
        if (popover && typeof popover.clearInputs === 'function') {
          popover.clearInputs();
        }
      }

      if (this.$refs.listComponent) {
        // 调用子组件的方法或直接操作 sortTable
        this.$refs.listComponent.clearSort();
      }

      for (let i = 1; i <= 9; i++) {
        const refName = `compressPopover${i}`;
        const popover = this.$refs[refName];
        if (popover && typeof popover.handleClear === 'function') {
          popover.handleClear();
        }
      }


        (this.levelName = "请选择"),
        (this.currentPage1 = 1),
        (this.selectAllText = "全选");
      this.selectAllBgColor = "#909399";

      delay(() => {
        sessionStorage.removeItem("grounding");
        getVdtCodeApi({
          process: this.process,
          all: "all",
          dup: this.Check,
          c: this.c,
        }).then(res => {
          if (res.code == 1000) {
            this.imgArr = res.data.data;
            this.total = res.data.total;
            this.listNum = {
              download_num: res.data.download_num,
              review: res.data.review,
              favorite: res.data.favorite,
              total: res.data.total
            };
            this.paginationInput = res.data.limit;
            this.operateNum.all = res.data.total;
          }
        });
      }, 300);
    },
    //本页全选
    selectAllEvt() {
      if (this.selectArr.length === this.imgArr.length) {
        this.imgArr = this.imgArr.map(res => {
          res.select = false;
          return res;
        });
        this.selectArr = [];
        this.selectAllText = "全选";
        this.selectAllBgColor = "#909399";
      } else {
        this.imgArr = this.imgArr.map(res => {
          res.select = true;
          return res;
        });
        this.selectArr = this.imgArr.filter(res => res.select == true);
        this.selectAllText = "取消全选";
        this.selectAllBgColor = "#909399";
      }
    },
    //点击删除  出现弹窗
    delete_Pop() {
      if (this.selectArr.length > 0) {
        this.deleteVisible = true;
      }
    },
    delete_Pop_box() {
      this.deleteVisible_box = true;
    },
    deleteEvt_box() {
      var arr = this.selectArr.map(val => {
        return val.source_id;
      });
      changeImgApi({
        process: 4,
        source_ids: this.spaceDialogId,
        c: this.c,
      }).then(res => {
        if (this.selectArr.length > 0) {
          this.selectArr.length--;
          this.spaceDialogNum -= 0;
          this.deleteVisible_box = false;
        }
        if (this.selectArr.length == 0) {
          this.deleteVisible_box = false;
          this.dialogVisible = false;
        }
      });
    },
    //删除已选中
    deleteEvt() {
      var arr = this.selectArr.map(val => {
        return val.source_id;
      });
      changeImgApi({
        process: 4,
        source_ids: arr,
        c: this.c,
      }).then(res => {
        if (res.code == 1000) {
          this.imgArr = this.imgArr.map(a => {
            this.selectArr.map(val => {
              if (a.source_id == val.source_id) {
                a = {};
              }
            });
            return a;
          });
          this.liEvt();
          this.deleteVisible = false;
          this.selectArr.length = "0";
        }
      });
    },
    //获取点击的是那张图片
    amplify(index) {
      this.xxm = true;
      this.currentImageIndex = index;
      // 将当前选中的图片的 selected 设置为 true
      this.arr.forEach((item, i) => {
        item.selected = i === index;
      });
    },

    //重新请求页面数据
    liEvt() {
      if (this.checkValue == true) {
        this.Check = 1;
        let grounding = JSON.parse(sessionStorage.getItem("grounding"));
        if (grounding) {
          this.authorInput = grounding.select.author;
          (this.value2 = grounding.select.time),
            (this.checkInput = grounding.select.checkInput);
          this.radio = grounding.select.radio;
          this.frontOrderInput = grounding.select.source_id;
          this.sort = grounding.select.sort;
          switch (grounding.select.sort) {
            case "8":
              this.sortName = "点击查看次数最多";
              break;
            case "9":
              this.sortName = "收藏最多";
              break;
            case "1":
              this.sortName = "上传时间-升序";

              break;
            case "2":
              this.sortName = "上传时间-降序";

              break;
            case "3":
              this.sortName = "文件大小-升序";

              break;
            case "4":
              this.sortName = "文件大小-降序";

              break;
            case "5":
              this.sortName = "文件尺寸-升序";

              break;
            case "6":
              this.sortName = "文件尺寸-降序";

              break;
            case "7":
              this.sortName = "下载次数最多";

              break;
          }
          getVdtCodeApi({
            process: this.process,
            is_tag: grounding.select.is_tag,
            not_tag: grounding.select.not_tag,
            author: grounding.select.author,
            time: grounding.select.time,
            tag_type: grounding.select.radio[0],
            tag_id: grounding.select.labelId,
            source_id: grounding.select.source_id,
            sort: grounding.select.sort,
            type: this.adminuser,
            dup: this.Check,
            c: this.c,
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total
              };
              if (grounding.select.labelId) {
                this.labelId = grounding.select.labelId;
                this.operateLabelInput = grounding.select.operateLabelInput;

                getVdtCodeApi({
                  is_tag: grounding.select.is_tag,
                  not_tag: grounding.select.not_tag,
                  source_id: grounding.select.source_id,
                  author: grounding.select.author,
                  time: grounding.select.time,
                  tag_id: grounding.select.labelId,
                  process: this.process,
                  type: this.adminuser,
                  dup: this.Check,
                  c: this.c,
                }).then(val => {
                  if (res.code == 1000) {
                    this.operateNum.show = true;
                    this.operateNum.all = res.data.total;
                    this.operateNum.belong = res.data.belong;
                    this.operateNum.not_belong = res.data.not_belong;
                    this.operateNum.not_review = res.data.not_review;
                    this.imgArr = res.data.data;
                    this.listNum = {
                      download_num: res.data.download_num,
                      review: res.data.review,
                      favorite: res.data.favorite,
                      total: res.data.total
                    };
                    let arr = [];
                    this.imgArr.map(v => {
                      res.data.data.map(l => {
                        if (v.source_id == l.source_id) {
                          v.status = l.status;
                          arr.push(v);
                        }
                      });
                    });
                    this.imgArr = arr;
                  }
                });
              }
            }
          });
        } else {
          getVdtCodeApi({
            process: this.process,
            dup: this.Check,
            c: this.c,
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total
              };
            }
          });
        }
      } else {
        this.Check = 2;
        let grounding = JSON.parse(sessionStorage.getItem("grounding"));
        if (grounding) {
          this.authorInput = grounding.select.author;
          (this.value2 = grounding.select.time),
            (this.checkInput = grounding.select.checkInput);
          this.radio = grounding.select.radio;
          this.frontOrderInput = grounding.select.source_id;
          this.sort = grounding.select.sort;
          switch (grounding.select.sort) {
            case "8":
              this.sortName = "点击查看次数最多";
              break;
            case "9":
              this.sortName = "收藏最多";
              break;
            case "1":
              this.sortName = "上传时间-升序";

              break;
            case "2":
              this.sortName = "上传时间-降序";

              break;
            case "3":
              this.sortName = "文件大小-升序";

              break;
            case "4":
              this.sortName = "文件大小-降序";

              break;
            case "5":
              this.sortName = "文件尺寸-升序";

              break;
            case "6":
              this.sortName = "文件尺寸-降序";

              break;
            case "7":
              this.sortName = "下载次数最多";

              break;
          }
          getVdtCodeApi({
            process: this.process,
            is_tag: grounding.select.is_tag,
            not_tag: grounding.select.not_tag,
            author: grounding.select.author,
            time: grounding.select.time,
            tag_type: grounding.select.radio[0],
            tag_id: grounding.select.labelId,
            source_id: grounding.select.source_id,
            sort: grounding.select.sort,
            type: this.adminuser,
            c: this.c,
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total
              };
              if (grounding.select.labelId) {
                this.labelId = grounding.select.labelId;
                this.operateLabelInput = grounding.select.operateLabelInput;

                getVdtCodeApi({
                  is_tag: grounding.select.is_tag,
                  not_tag: grounding.select.not_tag,
                  source_id: grounding.select.source_id,
                  author: grounding.select.author,
                  time: grounding.select.time,
                  tag_id: grounding.select.labelId,
                  process: this.process,
                  type: this.adminuser,
                  c: this.c,
                }).then(val => {
                  if (res.code == 1000) {
                    this.operateNum.show = true;
                    this.operateNum.all = res.data.total;
                    this.operateNum.belong = res.data.belong;
                    this.operateNum.not_belong = res.data.not_belong;
                    this.operateNum.not_review = res.data.not_review;
                    this.imgArr = res.data.data;
                    this.listNum = {
                      download_num: res.data.download_num,
                      review: res.data.review,
                      favorite: res.data.favorite,
                      total: res.data.total
                    };
                    let arr = [];
                    this.imgArr.map(v => {
                      res.data.data.map(l => {
                        if (v.source_id == l.source_id) {
                          v.status = l.status;
                          arr.push(v);
                        }
                      });
                    });
                    this.imgArr = arr;
                  }
                });
              }
            }
          });
        } else {
          getVdtCodeApi({
            process: this.process,
            c: this.c,
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
              this.operateNum.all = res.data.total;
              this.listNum = {
                download_num: res.data.download_num,
                review: res.data.review,
                favorite: res.data.favorite,
                total: res.data.total
              };
            }
          });
        }
      }
    },

    updateLocation() {
      let token = localStorage.getItem("token");
      window.location.href = 'https://dd.dang3d.com/login?token=' + token;
    },
    //  goToBaidu() {
    //   // 使用绝对路径跳转到www.baidu.com
    //   // window.location.href = 'http://www.baidu.com';
    // },

    contractEvt(num) {
      showMenuApi({ open: num }).then((res) => {
        if (res.code == 1000) {
          this.$store.dispatch("setContractNum", res.data.open);
        }
      });
    },
    outLoginEvt(e) {
      if (e == 1) {
        outLoginApi().then((res) => {
          if (res.code === 1000) {
            localStorage.removeItem("token");
            this.$router.push("/login");
          }
        });
      }
    },
    handleSelect() { },
    topMenuEvt(e) {
      if (e == 1) {
      } else if (e == 2) {
        this.menuList = [
          {
            id: "1",
            title: "模型进度",
            children: [
              {
                id: "1_1",
                title: "原始素材",
                next: "/original",
              },
              {
                id: "1_2",
                title: "整理中",
                next: "/1223",
              },
              {
                id: "1_3",
                title: "上架中",
                next: "/grounding",
              },
              {
                id: "1_4",
                title: "下架中",
                next: "/undercarriage",
              },
              {
                id: "1_5",
                title: "回收站",
                next: "/retrieve",
              },
            ],
          },
          {
            id: "2",
            title: "模型分类",
            children: [
              {
                id: "2_0",
                title: "未分类",
                next: "/0",
              },
              {
                id: "2_2",
                title: "人",
                next: "/1",
              },
              {
                id: "2_3",
                title: "交通",
                next: "/2",
              },
              {
                id: "2_1",
                title: "植物",
                next: "/199",
              },
              {
                id: "2_4",
                title: "家具",
                next: "/12432",
              },
              {
                id: "2_6",
                title: "场景",
                next: "/1123123",
              },
            ],
          },
          {
            id: "3",
            title: "自定义标签",
            children: [
              {
                id: "3_1",
                title: "人",
                next: "/1",
              },
              {
                id: "3_@",
                title: "交通",
                next: "/2",
              },
              {
                id: "3_#",
                title: "植物",
                next: "/199",
              },
              {
                id: "3_7",
                title: "家具",
                next: "/12432",
              },
              {
                id: "3_6",
                title: "场景",
                next: "/1123123",
              },
            ],
          },
        ];
        this.$router.push("/model");
      } else if (e == 3) {
        this.menuList = [
          {
            id: "1",
            title: "模型进度",
            children: [
              {
                id: "1_1",
                title: "原始素材",
                next: "/original",
              },
              {
                id: "1_2",
                title: "上架中",
                next: "/grounding",
              },
              {
                id: "1_3",
                title: "下架中",
                next: "/undercarriage",
              },
              {
                id: "1_4",
                title: "回收站",
                next: "/retrieve",
              },
            ],
          },
          {
            id: "2",
            title: "模型分类",
            children: [
              {
                id: "2_0",
                title: "未分类",
                next: "/0",
              },
              {
                id: "2_1",
                title: "人",
                next: "/1",
              },
              {
                id: "2_2",
                title: "植物",
                next: "/199",
              },
            ],
          },
        ];
        this.$router.push("/PSpeople");
      } else if (e == 4) {
        this.$router.push("/user");
      } else if (e == 5) {
        this.$router.push("/income_box");
      } else if (e == 6) {
        this.$router.push("/Search_Records");
      } else if (e == 7) {
        this.$router.push("/Reference_statistics");
      } else if (e == 8) {
        this.$router.push("/ai");
      }
      else if (e == 9) {
        this.$router.push("/translate_fanyi");
      }

      this.$store.dispatch("setMenuList", this.menuList);
    },
    // //测试
    // fatherMethod() {
    //  this.$nextTick(()=>{
    //    this.menuList = this.$store.getters.menuList
    //  });
    // }
    coverEvt() {
      this.$store.dispatch("setCoverShow", false);
    },

  },
};
</script>

 <style  lang="less" scoped>
@import url("../backHome/js/flex-images.css");
@import url("../backHome/js/flex-images.css");
@import url("../style/space.less");
@import url("../style/modelList.less");
@import url("../style/xinjian.less");

 @import url("../style/space.less");
  @import url("../style/space.less");

@import url("../style/list.less");

.cover_box {
  position: fixed;
  z-index: 452;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgb(95, 94, 94, 0.4);
}

.search-box {
  width: calc(100% - 190px);
  min-width: 100%;
  height: 60px;
  background: #fff;
  top: 60px;
  z-index: 1;
  border-bottom: 1px solid #c2b8b89c;
  /* transition: all .7s ease-in-out .7s;
          transform: translateZ(0); */
}

.block {
  position: fixed;
  right: calc(100% - 100%);
  top: 65px;
  /* transition: all .2s ease .2s; */
}

.maxx {
  min-width: calc(100% - 40%);
}

/deep/.el-input__inner {
  border: none;
}

.search-box1 {
  /* height: 0;
      visibility: hidden; */
  /* transition: all 0.3s ease-in-out 0.3s;
      transform: translate3d(0, -100%, 0);
      opacity: 0; */
  z-index: 111;
  position: fixed;
  background: #fff;
  width: calc(100% - 190px);
  min-width: 1200px;
  height: 90px;
}

.caoz {
  margin-top: 8px;
  display: flex;
}

.img-box {
  margin-top: 55px;
  background: #fff;
}

.img-box .item {
  position: relative;
  display: flex !important;
  justify-content: center;
}

.img-box .item img {
  object-fit: cover;
  width: 100%;
}

.img-box .item img:hover {
  /* transition: all .5s linear 0s;
          transform: scale(1.2);*/
}

.img-box .bottom_text {
  position: absolute;
  width: 100%;
  height: 20px;
  bottom: 0;
  font-size: 12px;
  color: #fff;
  display: flex;
  justify-content: space-between;
}

.img-box .bottom_text div {
  margin: 0 20px;
}

.id_text {
  position: absolute;
  top: 5px;
  left: 10px;
  color: #fff;
  font-size: 12px;
}

.bottom_text b {
  position: absolute;
  display: block;
  bottom: 6px;
  right: 5px;
  width: 14px;
  height: 14px;
  border: 1px solid #fff;
  border-radius: 50%;
}

.bottom_text i {
  display: block;
  position: absolute;
  height: 10px;
  width: 10px;
  bottom: 8px;
  right: 7px;
  border-radius: 50%;
}

.spaceDialog_box {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}

.spaceDialog_box .check div {
  width: 90px;
}

.spaceDialog_box .check {
  margin-top: 30px;
}

/* .spaceDialogImg {
      width: 555px;
      height: 850px;
      min-width: 550px;
      display: flex;
      min-height: 400px;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      border-right: 1px solid #eee;
      background-color: rgb(200, 200, 200, 0.2);
      position: relative;
      overflow: hidden;
  }

  .spaceDialogImg1 {
      width: 100%;
      height: 850px;
      min-width: 1080px;
      min-height: 400px;
      background-color: rgb(200, 200, 200, 0.2);
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
  } */
.spaceDialogImg img {
  object-fit: cover;
}

.spaceDialogImg1 img {
  object-fit: cover;
}

.info_box {
  position: absolute;
  bottom: 10px;
  left: 10px;
}

.info_box span {
  padding: 0 5px;
}

.belong_box {
  position: absolute;
  bottom: 10px;
  right: 250px;
  display: flex;
  justify-content: space-around;
}

.belong_box span {
  padding: 0 30px;
  position: relative;
  cursor: pointer;
}

.belong_box span b {
  font-size: 14px;
  font-weight: 400;
  color: #c02cac;
}

.belong_box span i {
  display: block;
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  border: 1px solid #999;
  margin-right: 5px;
  margin-top: 2px;
  z-index: 12;
}

.belong_box span strong {
  position: absolute;
  display: block;
  top: 4px;
  left: 32px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.allNo_box {
  position: absolute;
  bottom: 50px;
  right: 20px;
  font-size: 12px;
}

.allNo_box button {
  background-color: #fff;
  color: #c02cac;
  border: 1px solid #e1e1e1;
  padding: 5px 10px;
  cursor: pointer;
}

.changing_box {
  width: 60px;
  height: 20px;
  position: absolute;
  z-index: 1;
  top: 5px;
  left: 5px;
  text-align: center;
  cursor: pointer;
}

.all-box {
  font-size: 12px;
  color: #6a6a6a;
  margin-top: 5px;
}

.select {
  position: absolute;
  right: -25px;
  top: -25px;
  width: 0;
  height: 0;
  border: 25px solid;
  border-color: transparent #409eff transparent transparent;
  transform: rotate(135deg);
  color: #fff;
}

.select1 {
  position: absolute;
  left: 10px;
  top: 9px;
  width: 36px;
  height: 24px;
  color: #fff;
  background: #dd127b;
  border-radius: 6px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
}

.el-icon-check {
  position: absolute;
  font-size: 18px;
  top: -9px;
  left: 5px;
  transform: rotate(223deg);
}

.block1 {
  position: fixed;
  right: 1%;
  top: 1%;
}

.block1>div {
  /* display: none; */
}

.spaceLabel_box {
  max-width: 1100px;
  min-width: 600px;
  overflow-y: hidden;
  position: relative;
  transition: all 0.5s ease 0.2s;
}

.spaceLabel_box1 {
  height: 0;
  visibility: hidden;
  display: none;
}

.check {
  display: flex;
}

.check div {
  width: 100px;
}

.check div p {
  margin: 0;
  font-size: 14px;
  margin-bottom: 25px;
  padding-left: 14px;
}

.check div .checkbox {
  width: 100%;
  margin-top: 15px;
  position: relative;
  cursor: pointer;
  -webkit-touch-callout: none;
  /*系统默认菜单被禁用*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -khtml-user-select: none;
  /*早期浏览器*/
  -moz-user-select: none;
  /*火狐*/
  -ms-user-select: none;
  /*IE10*/
  user-select: none;
}

.check div .checkbox i {
  display: block;
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  border: 1px solid #999;
  margin-right: 5px;
  margin-top: 2px;
  z-index: 12;
}

.check div .checkbox b {
  display: block;
  width: 8px;
  height: 8px;
  position: absolute;
  top: 4px;
  left: 2px;
  border-radius: 50%;
}

.num-box {
  position: absolute;
  bottom: 10px;
  right: 48%;
  font-size: 12px;
}


.operation_box {
  position: absolute;
  bottom: 12px;
  left: 17px;
  color: #fff;
  cursor: pointer;
}

.operation_box button {
  padding: 0;
  font-size: 18px;
  color: #fff;
  background: rgba(248, 248, 248, 0);
}

.operation_center {
  display: flex;
  position: relative;
  height: 300px;
  margin-top: 10px;
}

.center_box span {
  padding-left: 33px;
  font-size: 13px;
}

.center_box .el-checkbox {
  margin-top: 15px;
}

.all_text {
  background-color: #409eff;
  font-size: 13px;
  color: #fff;
  cursor: pointer;
  padding: 5px 20px;
  border-radius: 3px;
  margin-left: 10px;
}

.arrow_box {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.arrow_box div {
  width: 10%;
  height: 100%;
}

.arrow_box .left:hover {
  cursor: url("../backHome/components/cur/left.png"), auto;
}

.arrow_box .right:hover {
  cursor: url("../backHome/components/cur/right.png"), auto;
}

.rightSearch {
  position: absolute;
  bottom: 43px;
  left: 33px;
}

.space_title:hover {
  background-color: rgb(154, 46, 46) !important;
  color: #fff;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/deep/ .center_box .el-checkbox .el-checkbox__label {
  color: #a1a1a1;
}

.operation_center .btn_box {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

/deep/ .searchLabel {
  min-width: 1250px;
  min-height: 650px;
}

/deep/ .spaceDialog {
  /*max-width: 1730px;*/
  min-width: 1200px;
  transform: translateY(-80px);
}

@media screen and (min-width: 2500px) {
  .check div p {
    font-size: 15px !important;
  }

  .checkbox {
    font-size: 14px !important;
  }
}

/deep/ .el-pager .number {
  font-size: 12px;
  color: #6a6a6a;
}

/deep/ .el-pager li.active {
  color: #409eff;
}

button {
  border: none;
}

/deep/ .el-range-separator {
  width: 13%;
  padding: 0;
}

/deep/ .el-dialog__body {
  font-size: 12px;
  padding: 10px 20px;
}

/deep/ .spaceDialog .el-dialog__body {
  // padding: 0 10px;
  min-height: 600px;
}

/deep/ .spaceDialog .el-dialog__header {
  padding: 5px 0;
}

/deep/ .spaceDialog .el-dialog__footer {
  padding: 10px 20px 5px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

.el-checkbox-group {
  margin-left: 10px;
  font-size: 12px;
  line-height: 28px;
}

/deep/ .el-time-panel.el-popper {
  display: none;
}

/deep/ .el-loading-mask {
  height: 100vh;
}

/deep/ .el-checkbox__label {
  font-size: 12px;
  font-family: Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
  font-weight: 400;
}

// /deep/ .is-disabled .el-checkbox__inner {
//   background-color: #409eff !important;
//   border-color: #409eff !important;
// }

/deep/ .is-disabled .el-checkbox__inner::after {
  border-color: #fff !important;
}

/deep/ .is-disabled span {
  color: #409eff !important;
  cursor: pointer !important;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #909399;
  border-color: #909399;
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #909399;
}

/deep/ .flex-images {
  overflow-y: scroll !important;
  /* height: 83.5vh; */
}

/* 需要根据媒体查询更改的样式 */
.main_header {
  display: flex;
  justify-content: space-between;
  height: 89px;
  position: fixed;
  width: 90%;
  z-index: 111;
  border-bottom: 1px solid #c2b8b89c;
}

/* 需要根据媒体查询更改的样式 */
/* .changing-box {
      position: absolute;
      top: 50px;
      right: 1.2%;
    } */

/* 需要根据媒体查询更改的样式 */
.changing-box .shangchuan {
  padding: 5px 15px;
  background: #66b1ff;
  font-size: 12px;
  color: #fff;
  margin-right: 10px;
  border-radius: 3px;
}

.changing-box .clone {
  font-size: 12px;
  padding: 5px 15px;
  background: #a6a9ad;
  color: #fff;
  border-radius: 3px;
  margin-right: 15px;
}

.main_center {
  min-width: 500px;
  display: flex;
  justify-content: end;
  margin-top: 10px;
}

.check_min {
  .is-checked {
    /deep/.el-checkbox__inner {
      background-color: #409eff !important;
    }

    /deep/.el-checkbox__label {
      color: #409eff !important;
    }
  }
}

.your-css-class {
  background-color: #bcd9f8d4 !important;
  z-index: 9999;

  input {
    background-color: #bcd9f8d4 !important;
  }
}

.your-css-class_box {
  background-color: #bcd9f8d4 !important;

  input {
    background-color: #bcd9f8d4 !important;
  }
}

.orange {
  /deep/.el-input__inner {
    background-color: #bcd9f8d4 !important;
    color: #222222;
  }

  /deep/.el-input__suffix {
    color: #222222;
  }
}

/deep/.el-range-editor--mini {
  height: 30px !important;
}

.container {
  height: auto;
  width: 60%;
  margin-bottom: 20px;
}

.checked_box {
  border: 1px solid;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.box_item {
  width: 500px;
  height: 323px;
  border: 1px solid;
  margin: 5px;
  position: relative;
}

.button_container {
  position: absolute;
  bottom: 15px;
  right: 20px;
}

.btn {
  background: #fff;
  width: 20px;
  height: 20px;
  margin-left: 5px;
  border-radius: 50%;
  cursor: pointer;
}

.outer_btn {
  display: block;
  margin-top: 10px;
  float: right;
}

.checked_box1 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

 .checked_box1 .box_item {
   width: 100%;
    height: 1000px;
 }

#container {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#image-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  // align-items: center;
}

.image-wrapper {}

/* CSS样式 */
.small-image {
  /* 图片宽度为100%，即根据盒子的宽度进行缩放 */
  width: 380px;
  /* 图片高度为100%，即根据盒子的高度进行缩放 */
  height: 260px;
  object-fit: contain;
  /* 按比例缩放图片，覆盖整个内容框 */
  /* 小图片的宽高 */
  background: #d1d1d1;
  cursor: zoom-in;
}

#image-container .large-image {
  width: 900px;
  /* 大图片宽度为容器的宽度 */
  height: auto;
  /* 高度自适应 */
  display: block;
}

.img_container {
  margin: auto;
}

.large-view {}

//两个按钮点击样式
.button-container {
  display: flex;
  justify-content: space-between;
  z-index: 111 !important;
  margin-top: 5px;
}

.button-container img:nth-child(1) {
  right: 75px;
  bottom: -20px;
}

.button-container img:nth-child(2) {
  right: 25px;
  bottom: -20px;
}

.prev-button {
  position: absolute;
  height: 90%;
  margin-right: 50vh;
  width: 10%;
  opacity: 0;
  cursor: url("../backHome/components/cur/left.png"), auto;
}

.next-button {
  position: absolute;
  height: 90%;
  right: 10px;
  width: 10%;
  opacity: 0;
  cursor: url("../backHome/components/cur/right.png"), auto;
}

.check_box {
  position: absolute;
  z-index: 1;
  bottom: 5px;
  right: 30px;
  text-align: center;
  cursor: pointer;
  border: none;
}

.check_box img:nth-child(1) {
  background: #fff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.check_box img:nth-child(2) {
  background: #fff;
  width: 30px;
  height: 30px;
  margin-left: 10px;
  border-radius: 50%;
}

.repeat_v {
  width: 95%;
}

.repeat_b {
  display: flex;
  width: 98%;
  justify-content: space-between;
}

.repeat_b img {
  cursor: pointer;
}


.repeat_box {
  display: flex;
  justify-content: space-between;
}

.repeat_box span:nth-child(2) {
  font-size: 16px;
}

.repeat_box span:nth-child(3) {
  width: 80px;
  cursor: pointer;
  text-align: center;
  background: #dd127b;
  padding: 7px;
  color: #fff;
  border-radius: 4px;
  height: 31px;
}



.contract {
  cursor: pointer;
  margin-left: 20px;
  float: left;
  color: #409eff;
}

.cover_box {
  position: fixed;
  z-index: 452;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgb(95, 94, 94, 0.4);
}

/*铺满屏幕，没有边距*/
.el-container {
  padding: 0px;
  margin: 0px;
  height: 100vh;
}

.el-header {
  /* 顶部部分的高度(默认60px) */
  color: #ffffff;
  font-size: 20px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 60px;
  z-index: 12;
  box-shadow: 0px 1px 3px 1px hsla(0, 0%, 89%, 0.4);
  /* transition: all 0.8s ease 0s; */
  transition: all .6s ease .6s;
  opacity: 1;
  border-bottom: 1px solid #c2b8b89c;
}

.el-header1 {
  color: #ffffff;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0px !important;
  transition: all .7s ease .4s;
}

.el-aside {
  width: 10% !important;
  max-width: 260px !important;
  min-width: 180px !important;
  min-height: calc(100vh - 60px);
  border-right: 1px solid #e5e5e5;
}

.el-aside .el-menu {
  width: 90%;
  min-height: 100%;
  border: none;
  margin-left: 5%;
  font-weight: normal;
}

.el-menu span {
  margin-left: 10px;
}

.el-mian {
  /*background-color: #e5e5e5;*/
  min-width: 600px;
  position: relative;
  padding: 0px;
  margin: 0;
  height: 100vh;
  /* height: calc(100vh - 60px);*/
  overflow: hidden;
}

.el-aside .is-active {
  border-radius: 8px;
  background-color:#F0F0F0 ;
  color: #373535;
}

.headerMenu {
  height: 58px;
}

.headerMenu .el-menu--horizontal {
  border: none;
}

.headerMenu .el-menu {
  background-color: rgba(226, 226, 226, 0) !important;
}

/deep/.el-submenu__title {
  font-family: Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
  font-size: 12px !important;
  height: 40px;
  line-height: 40px;
  margin-top: 5px;
}

.el-menu-item:focus,
.el-menu-item:hover {
  border-radius: 8px;
  background-color: rgba(233, 244, 254, 1);
}

.el-menu-demo .el-menu-item:hover {
  border-radius: 0px;
}

.el-menu-demo .el-menu-item {
  border-radius: 0;
  font-size: 12px;
}

.menu_scroll {
  overflow-y: scroll !important;
  height: 89vh !important;
}

.switching {
  width: 60px;
  height: 20px;
  font-size: 14px;
  color: #000;
  padding: 2px 8px;
}

/deep/.is-horizontal {
  display: none;
}

/deep/.is-opened ul li div {
  border-bottom: 1px solid #eee;
  background: none !important;
}

/deep/.leftMenu .is-opened {
  background: none !important;
}

/deep/.el-menu-item-group__title {
  display: none;
}

/deep/.el-scrollbar__wrap {
  overflow-y: scroll !important;
  height: 96% !important;
}

/deep/.el-radio-button__inner {
  padding: 4px 20px;
  background: #d1d1d1 !important;
  border: none;
  outline: none;
}

/deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background: #fff !important;
  color: #000;
  border: none !important;
  outline: none !important;
  /* 移除点击状态的虚线边框 */
  box-shadow: 0 0px !important;
}

/deep/.el-radio-button:first-child .el-radio-button__inner {
  border: none;
}





/deep/.sousuo .el-dialog__header {
  padding: 0 !important;
}

/deep/.sousuo .el-input__inner {
  height: 38px !important;
  cursor: pointer;
}


.all_input {
  margin-top: 10px;
  margin-left: 15px;
  display: flex;
  align-items: center;

  span {
    width: 60px;
    font-size: 11px;
    text-align: end;
    margin-right: 5px;
  }

  .el-input {
    width: 160px;
    height: 40px;
    border: 1px solid;
    border-radius: 5px;
  }

  .el-select {
    border: 1px solid;
    border-radius: 5px;
  }

  /deep/.el-input__icon {
    line-height: 38px !important;
    cursor: pointer;
  }
}



.dropdown-container {
  position: relative;
  width: 80px;
  cursor: pointer;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  text-indent: 5px;
  line-height: 5px;
}

.arrow-icon {
  width: 10px;
  height: 10px;
  border-top: 2px solid #e5e5e5;
  border-right: 2px solid #e5e5e5;
  transform: rotate(135deg);
  margin-left: 5px;
  margin-bottom: 5px;
}

.dropdown-trigger {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.dropdown-menu {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  margin-top: 30px;
  width: 100px;
  right: 5px;
  /* 调整宽度以适应你的需求 */
}

.menu-item {
  padding: 5px;
  text-align: center;
}

.menu-item:hover {
  background-color: #f0f0f0;
}

/deep/.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #F0F0F0 !important;
  height: 30px !important;
}

/deep/.filter-tree .el-tree-node__content {
  height: 30px !important;
}

/deep/.filter-tree .custom-tree-node {
  margin-right: 15px !important;
}

.max_scroll /deep/.el-scrollbar__bar.is-vertical{
  width: 0px !important;
}

@media screen and (min-width:0px) and (max-width: 1920px) {
  .left_evt{
    width: 100px !important;
  }
  .filter-tree .custom-tree-node{
      margin-right:0px !important;
  }
  .menu_scroll {
      overflow-y: scroll !important;
      height: 84vh !important;
    }
  /deep/.spaceDialog {
    height: 87vh !important;
  }

  .menus_input {
    width: 160px !important;
  }

  .width_ect {
    width: 850px !important;
  }
}

@media screen and (min-width:1921px) and (max-width: 2560px) {
  .width_ect {
    width: 1480px !important;
  }
}

@media screen and (min-width:2561px) and (max-width: 3440px) {
  .width_ect {
    width: 2200px !important;
  }
}

@media screen and (min-width:3441px) and (max-width: 3840px) {
  .width_ect {
    width: 2500px !important;
  }
}

.border_box_e {
  height: 30px;
}

.border_box_e /deep/.el-input__inner {
  height: 28px !important;
}

.border_box_e /deep/.el-input__icon {
  line-height: 26px !important;
}

.border_box_e {
  border: 1px solid #858585 !important;
  border-radius: 5px;
}

.border_box_e /deep/.input_e {
  height: 27px !important;
}

.all_input_e {
  margin-top: 5px !important;
  margin-left: 5px !important;
  display: flex;
  align-items: baseline !important;
}

.all_input_e /deep/span {
  width: 5px !important;
}

.all_input_e /deep/.input_e {
  height: 28px !important;
  line-height: 21px !important;
}

.all_input_e /deep/.input_e .el-input__inner {
  height: 26px !important;
}

.width_ect {
  overflow-y: scroll;
  /* 启用滚动 */
  height: 70px;
  /* 设置固定高度 */
}

/* 隐藏滚动条 */
.width_ect::-webkit-scrollbar {
  display: none;
}

/* 兼容非WebKit浏览器（如Firefox） */
.width_ect {
  scrollbar-width: none;
  /* Firefox */
}

.size_ect {
  height: 30px !important;
}

.size_ect /deep/.input_e {
  height: 30px !important;
}



/deep/ .el-input .el-input__clear:hover{
color: #f00 !important;
}
/deep/ .el-date-editor .el-range__close-icon{
color: #f00 !important;
}
/deep/.el-select .el-input .el-icon-circle-close{
  color: #f00 !important;
}
/deep/.sousuo .el-dialog__header {
  padding: 0 !important;
}

/deep/.sousuo .el-input__inner {
  height: 38px !important;
  cursor: pointer;
}

.flex-images .item{
  margin:6px !important;
}
</style>

<style>
.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 10px;
}

.el-picker-panel__shortcut {
  font-size: 12px !important;
}

.your-css-class .el-range-input {
  background-color: #8fc6ff00 !important;
}

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

::placeholder {
  color: #858585 !important;
}

.num_box button {
  width: 125px;
  border: 1px solid #858585;
  border-radius: 5px;
  background-color: #fff;
  color: #909399;
  height: 30px;
}

.num_box button:hover {
  width: 125px;
  background-color: #fff;
  color: #909399;
  border: 1px solid #858585;
}

.selt {
  color: #858585 !important;
}

.vip-button {
  color: #000 !important;
  background-color: #bcd9f8d4 !important;
}
</style>



// WEBPACK FOOTER //
// src/backHome/index.vue